export default {
    "corporate": "Programa corporativo",
    "onboarding": {
        "goal_desc": "Ganarás %{customPoints} por el monitoreo de tu actividad y %{customPoints} en bonificaciones por completar tus objetivos. ¡Es hora de empezar! Puedes tener 3 objetivos personales activas en cualquier momento.",
        "sample_task": {
            "modalActivityTitle": "3 respiraciones profundas",
            "rewards_featured_title": "Destacado",
            "rewards_partners_title": "Socios",
            "header_description": "Ganarás %{customPoints} si monitoreas tu actividad y completas tareas, objetivos y desafíos.",
            "icon_text": "Toca el {icon} para monitorear una respiración profunda.",
            "activityName": "respiración profunda",
            "activityUnit": "respira"
        },
        "lets_get_started": "¡Empecemos!",
        "start_description": "Ganarás %{customPoints} si monitoreas tu actividad y completas tareas, objetivos y desafíos.",
        "complete_and_earn": "Completa y gana",
        "did_it": "¡Lo hice!",
        "task_complete": "¡Tarea completada!",
        "breath_sample_task": "Completa un breve tutorial sobre el monitoreo de la actividad",
        "track_a_sample_activity": "Monitorea una actividad de muestra",
        "nice": "¡Bien!",
        "nice_one": "¡Bien hecho!",
        "nice_subtext_1": "Has ganado %{points} %{customPoints}.",
        "nice_subtext_2": "Ganar %{customPoints} te ayudará a subir de nivel. Cada vez que subas de nivel ganarás %{reward_currency} que puedes canjear por grandes ofertas.",
        "nice_subtext_3": "Ganarás más puntos cuando completes más tareas, monitorees la actividad y completes los objetivos y desafíos.",
        "progress_subtitle": "Tus %{customPoints} y el progreso se reinician cada %{frequency}.",
        "skip_for_now": "Saltar por ahora",
        "loadingText": "Espera mientras calculamos tu puntuación de bienestar.",
        "goal_title": "Fija un objetivo personalizado",
        "swipe_for_more": "Desliza para ver más",
        "skip_goals": "Ya fijé objetivos por ahora.",
        "complete_profile": "",
        "level": "Nivel",
        "finish_onboarding_action": "Completa la incorporación primero",
        "vital_stats": {
            "height_ft": "Altura pie.",
            "height_in": "Altura pulg."
        },
        "rewards": "",
        "welcome": {
            "disclaimerTitle": "Tu privacidad es importante"
        },
        "levels": {
            "title": "Logros y recompensas",
            "tableTitle": "Logros"
        },
        "initialScreen": {
            "title": "¡Bienvenido a %{programName}, %{username}!",
            "getRewarded": "Serás recompensado con %{rewardName}",
            "completeAgainst": "Compite contra tus colegas",
            "earnPoints": "Gana puntos con actividades de bienestar",
            "levelUp": "Sube de nivel y desbloquea las insignias"
        },
        "starterGoals": {
            "title": "Elige un objetivo",
            "subtitle": "Empieza tu viaje de bienestar con un nuevo hábito saludable."
        }
    },
    "healthkit_not_available": "No te puedes conectar con Apple Health. En la aplicación de Salud, debajo de Fuentes, asegúrate de tener al menos un permiso habilitado para los pasos y tener al menos un paso monitoreado.",
    "changeCover": "Cambia foto",
    "joiningCommunityToast": {
        "success": {
            "message": "Te has unido exitosamente a %{name}",
            "title": "Únete a la comunidad"
        }
    },
    "achievement_starts_date": "Inicia: %{date}",
    "editChallenge": "Edita %{challengeName}",
    "createChallenge": {
        "activitiesOrCategory": {
            "subtitle": "Escoge hasta 5 actividades",
            "title": "¿Qué te gustaría hacer?",
            "noActivityTitle": "Agregando actividades",
            "noActivityMessage": "Selecciona al menos una actividad o categoría.",
            "categoryItemDescription": "Todas las actividades en la categoría %{category}",
            "addActivityTitle": "¿Cuántos %{unit} de %{activity} quieres hacer por %{period}?",
            "addCategoryQuantityTitle": "¿Cuántos %{customPoints} quieres ganar en la categoría %{category}?",
            "subtitleCategories": "Selecciona una categoría. Todas las actividades de esa categoría contribuirán al objetivo.",
            "subtitleWithActivities": "%{num} de %{max} actividades seleccionadas",
            "selectCategoryMessage": "Se seleccionarán todas las actividades de la categoría y se descartarán las actividades previamente seleccionadas.",
            "addActivityTitleTotal": "¿Cuánta %{activity} quieres hacer en %{period}?"
        },
        "inviteDepartments": {
            "title": "Invita a los departamentos \/ divisiones"
        },
        "inviteRegions": {
            "title": "Invita a las regiones"
        },
        "createInvitation": {
            "selectMore": "Selecciona al menos el 2 %{entity}s!"
        },
        "visibility": {
            "title": "Visibilidad",
            "description": "Todos los usuarios %{programName} pueden encontrar y unirse a los desafíos de equipo."
        },
        "highest": {
            "name": "La mayoría %{customPoints} gana",
            "description": "No hay límites, el mayor %{customPoints} ocupa el 1er lugar"
        },
        "compete": {
            "individual": "Competir solo",
            "team": "Competir en equipo"
        },
        "unitType": {
            "title": "Selecciona cómo completar tu objetivo",
            "subtitle": "Elige entre las actividades o una categoría"
        },
        "category": {
            "name": "Todas las actividades de una categoría",
            "description": "Por ejemplo, monitorea cualquier actividad en 'Muévete'",
            "title": "Elige una categoría",
            "subtitle": "¿De qué categoría se monitorearán las actividades?"
        },
        "activities": {
            "name": "Actividades seleccionadas",
            "description": "Por ejemplo, monitorea actividades específicas como el ciclismo",
            "title": "Elige las actividades",
            "subtitle": "Recomendamos enfocarse en una sola actividad pero se pueden agregar hasta 5",
            "maxModalTitle": "Actividades máximas seleccionadas",
            "maxModalDescription": "Puedes agregar 5 actividades como máximo. Toca Aceptar para continuar con las 5 actividades seleccionadas o Editar para hacer cambios.",
            "warningModalTitle": "Dificultad alta",
            "warningModalDescription": "Has especificado mucha actividad para completar por período en este objetivo. ¿Estás seguro de que quieres fijar un objetivo tan desafiante?",
            "requiredPoints": "requerido para cumplir con el %{challengeType} de %{period}",
            "noActivitiesModalTitle": "Agregando actividades",
            "noActivitiesModalDescription": "Selecciona al menos una actividad."
        },
        "categoryQuantity": {
            "title": "Fija tu objetivo de %{customPoints}",
            "subtitle": "¿Cuántos %{customPoints} quieres ganar de %{category} cada %{period}?",
            "subtitleTotal": "¿Cuántos %{customPoints} quieres ganar de %{category} %{period}?",
            "text": "Guía: 30 minutos de actividad moderada es igual a aproximadamente 105 %{customPoints}",
            "noQuantityModalTitle": "Cantidad",
            "noQuantityModalDescription": "Introduce un valor",
            "defaultCategoryTitle": "categoría actual"
        },
        "cancel": {
            "title": "Cancelar la creación del desafío",
            "message": "¿Estás seguro de que quieres cancelar la creación del desafío?"
        },
        "createNew": "Crear un nuevo desafío",
        "chooseChallengeTitle": "Elige un desafío o crea el tuyo propio",
        "createOwn": {
            "title": "Crear mi propio"
        },
        "frequency": {
            "title": "¿Con qué frecuencia cumplirás tu objetivo?",
            "subtitle": "Los objetivos diarios son grandes creadores de hábitos"
        },
        "startAndDuration": {
            "title": "Elige una fecha de inicio y una duración",
            "subtitle": "",
            "noFieldsTitle": "Fecha de inicio y duración",
            "noFieldsMessage": "Rellena la fecha de inicio y la duración"
        },
        "finalize": {
            "title": "Revisa tu nuevo objetivo",
            "subtitle": "",
            "noFieldsTitle": "Nombre e instrucciones",
            "noFieldsMessage": "Rellena el nombre y las instrucciones",
            "name": "Mi objetivo %{names} de %{frequency}",
            "instructionCategory": "Gana %{points} %{customPoints} %{frequency} de todas las actividades %{category}",
            "instructionActivities": "Monitorea %{items} %{frequency} y gana %{points} %{customPoints} %{pointsFrequency}",
            "instructionCompetitionCategory": "Obtén la mayor cantidad de %{customPoints} de todas las actividades de %{category} para ganar este concurso",
            "instructionCompetitionActivities": "Obtén la mayor cantidad de %{customPoints} de %{items} para ganar este concurso",
            "namePlaceholder": "Nombra tu competencia",
            "titleChallenge": "Finaliza tu desafío"
        },
        "dailyDescription": "Por ejemplo, beber 8 vasos de agua al día",
        "weeklyDescription": "Por ejemplo, caminar 150 minutos cada semana",
        "monthlyDescription": "Por ejemplo, correr 150 km cada mes",
        "totalDescription": "Por ejemplo, el ciclo de un total de 10.000 kms.",
        "title": "¿Desafíate a ti mismo o a los demás?",
        "navigatorTitle": "Crear un desafío",
        "me": {
            "name": "Sólo yo",
            "description": "Desafíate a ti mismo con un objetivo personal"
        },
        "others": {
            "name": "Competir con otros",
            "description": "Competir individualmente o en equipo"
        },
        "one": {
            "name": "Individualmente",
            "description": "Completa individualmente con otros usuarios"
        },
        "team": {
            "name": "Como un equipo",
            "description": "Completa como un equipo con otros equipos"
        },
        "company": {
            "name": "El desafío de la compañía",
            "description": "Crear una competencia especial"
        },
        "adminItemTitle": "Como administrador, puedes crear",
        "userOrTeamTitle": "¿Competir individualmente o en equipo?",
        "target": {
            "name": "Fíjate un objetivo a cumplir",
            "description": "Desafío que tiene un límite superior"
        },
        "typeTitle": "Elige un tipo de %{challengeType}",
        "teamSizeTitle": "Elige un tamaño para cada equipo",
        "teamSizeSubtitle": "El tamaño mínimo de un equipo es %{min} y el máximo es %{max}. Los %{customPoints} de tu equipo son el promedio de todos los miembros del equipo y sólo puedes ganar %{customPoints} cuando tu equipo ha cumplido con el número mínimo de miembros.",
        "teamSize": {
            "noFieldsTitle": "Mínimo y máximo",
            "noFieldsMessage": "Elige el número mínimo y máximo de miembros de un equipo"
        },
        "companyChallengeTitle": "Desafío de la compañía",
        "companyChallengeSubtitle": "Eres un administrador. Puedes fijar desafíos departamentales y de otro tipo",
        "chooseDepartmentTitle": "Elige los departamentos para competir",
        "chooseRegionTitle": "Elige las regiones para competir",
        "goToChallenge": "Ve a mi desafío",
        "additional": {
            "title": "Desafío creado",
            "subtitle": "¡Empecemos! Invita a otros a unirse.",
            "makePublicName": "Hacerlo público",
            "makePublicDescription": "Cualquiera puede unirse",
            "toDirectoryName": "Enviar al Directorio de Desafíos",
            "toDirectoryDescription": "Las personas pueden crear uno como este",
            "inviteTitle": "Invitar a desafiar",
            "titleGoal": "¡Objetivo creado!"
        },
        "quantityMinimum": {
            "message": "La cantidad mínima requerida es %{quantity}",
            "title": "Cantidad insuficiente"
        },
        "toast": {
            "success": "Tu %{challengeType} ha sido creado."
        },
        "goToGoal": "Ve a mi objetivo",
        "navigatorTitleGoal": "Crear un objetivo",
        "quantityError": {
            "wholeNumber": "Debe ser un número entero",
            "greaterThanZero": "Debe ser mayor que 0"
        }
    },
    "wellbeing": {
        "description": {
            "overall": "Tu puntuación de bienestar se calcula comparando las respuestas que diste en la encuesta sobre el bienestar con las de millones de personas en tu misma categoría de edad y género. Tu puntuación demuestra en qué posición estás en relación con ellos y se actualizará automáticamente cada mes, de acuerdo con los cambios que se introduzcan en el app en relación con tus comportamientos de movimiento, alimentación y sensación. Si fijas objetivos consistentes y adoptas medidas positivas para mejorar tu salud pueden ayudarte a aumentar tu puntuación de bienestar.",
            "excellent": "Su puntuación de salud es mejor que la del 85% de las personas de su edad y sexo.",
            "very_good": "Su puntuación de salud es mejor que la del 70-84% de las personas de su edad y sexo.",
            "good": "Su puntuación de salud es mejor que la del 51-69% de las personas de su edad y sexo.",
            "fair": "Su puntuación de salud es mejor que la del 31-50% de las personas de su edad y sexo.",
            "poor": "Su puntuación de salud es más baja que la del 70% de las personas de su edad y sexo. Nunca es demasiado tarde para comenzar a priorizar su salud. ¡Aproveche nuestra plataforma para avanzar por su camino del bienestar!",
            "overall_result": "En general, tu puntuación de bienestar es %{status}.",
            "category_result": "En general, tu puntuación de {category} es {string}.",
            "goals": "No puedes ganar sin objetivos. Fija hasta 3 objetivos personales y sigue el camino hacia ellos. Con el tiempo, a medida que hagas cambios en tu estilo de vida, verás que tu puntuación aumenta."
        },
        "reminder": {
            "title": "¡Es hora de actualizar tu encuesta sobre el bienestar!",
            "updateAnswers": "Actualizar mis respuestas"
        },
        "lastUpdated": "Última actualización %{date}",
        "scoreDescription": {
            "part1": "Tu puntuación es",
            "part2": "puntuación de",
            "belowAverage": "por debajo del promedio",
            "aboveAverage": "por encima del promedio",
            "part3": "para otras personas de tu edad y sexo."
        },
        "improveScore": {
            "description": "Tu puntaje se calcula en base a las respuestas de la encuesta sobre el bienestar y a la actividad registrada. Puedes actualizar tus respuestas de la encuesta o fijar nuevos objetivos para mejorar.",
            "desc1": "¡Tu puntaje no puede subir mucho más! Para que tus rutinas sean interesantes, desafíate con objetivos que excedan tu capacidad normal e invita a otras personas a competir contigo para mantenerte motivado.",
            "desc2": "Si estás listo para aumentar de nivel, es hora de incrementar el desafío. Desafíate con objetivos que excedan tu capacidad normal e invita a otras personas a competir contigo para mantenerte motivado.",
            "desc3": "Establece metas personales y crea desafíos públicos que te responsabilicen y mantengan motivado. Asegúrate de seleccionar objetivos que puedas alcanzar y plazos de tiempo más cortos; recomendamos 1 semana.",
            "desc4": "Es importante mantenerse activo todos los días. Si tu rutina diaria no incluye mucho movimiento, establece metas pequeñas al principio que sean aptas para tus habilidades e intereses. Asegúrate de seleccionar objetivos que puedas alcanzar y plazos de tiempo más cortos; recomendamos 1 semana."
        },
        "recommendedGoals": "Objetivos recomendados",
        "recommendedDescription": {
            "desc1": "Puedes configurar hasta ",
            "desc2": "3 objetivos",
            "desc3": " para enfocarte en mejorar tu bienestar. Actualmente tienes "
        },
        "categoryScore": "Tu puntuación %{category} es ",
        "learnMore": "Aprende más",
        "youAreSet": "¡Estás listo!",
        "goalSetting": "Fíjate objetivos",
        "attention": "%{category} puntuación no disponible.",
        "move": {
            "error": "Según tus respuestas, tu puntuación de movimiento no está disponible."
        },
        "eat": {
            "error": "Indicaste que un profesional de la salud te ha dicho que tiene Diabetes tipo 2 y que no está controlada."
        },
        "feel": {
            "error": "Según tus respuestas, tu puntuación de sentimiento no está disponible."
        },
        "survey": {
            "requiredField": "* este campo es obligatorio"
        },
        "score_info_title": "Lo que significa mi puntuación",
        "company_average_info": "Promedio en mi empresa",
        "demographic_average_info": "El promedio en mi demografía",
        "score": "Puntuación del bienestar",
        "table": {
            "what_it_means": "Lo que significa",
            "score": "Puntuación"
        },
        "updated": "Actualizado",
        "label": {
            "excellent": "Excelente",
            "very_good": "Muy bien",
            "good": "Bien",
            "fair": "Regular",
            "poor": "Deficiente"
        },
        "activity": {
            "eat": "Actividad de comer 1, Actividad de comer 2, Actividad de comer 3",
            "move": "Actividad Muévete 1, Actividad Muévete 2, Actividad Muévete 3",
            "feel": "Actividad de sentir 1, Actividad de sentir 2, Actividad de sentir 3"
        },
        "score_info_screen": "¿Cómo se calcula mi puntuación?",
        "details": "Detalles",
        "activities": "Actividades",
        "improveCategoryScore": "Mejorar mi puntuación en %{category}",
        "meaning": {
            "heading": "Cálculo de la puntuación"
        },
        "score_button": {
            "meaning": "¿Qué significa esta puntuación?"
        },
        "improve": "Ver los objetivos recomendados",
        "score_text": {
            "demographic": "La puntuación promedio para tu edad y género es",
            "company": "y la puntuación promedio en tu empresa es"
        },
        "scoreHigher": "superior al promedio de",
        "scoreLower": "inferior al promedio de",
        "settedGoals": {
            "noGoals": "No se han fijado objetivos",
            "one": "1 objetivo fijado",
            "n": "%{count} objetivos fijados"
        },
        "yourScoreIsPoor": "Tu puntuación en %{category} es deficiente",
        "unlock": {
            "title": "Desbloquea tu puntuación de bienestar",
            "description": "Rellena un breve cuestionario para saber cómo tu salud general se compara con la de otras personas de tu demografía."
        },
        "browseAndSet": "Puedes buscar y establecer nuevas metas después de que hayas finalizado tus metas actuales.",
        "excellent": {
            "desc1": "Un estilo de vida excepcionalmente saludable",
            "desc2": "Riesgo muy bajo para la salud"
        },
        "veryGood": {
            "desc1": "Un estilo de vida muy saludable",
            "desc2": "Riesgo bajo para la salud"
        },
        "good": {
            "desc1": "Estilo de vida saludable",
            "desc2": "Riesgo promedio para la salud"
        },
        "fair": {
            "desc1": "Un estilo de vida un poco saludable",
            "desc2": "Riesgo superior al promedio para la salud"
        },
        "poor": {
            "desc1": "Riesgo alto para la salud",
            "desc2": "Se recomienda mayor movimiento diariamente",
            "desc3": "Se necesita mayor movimiento diariamente"
        },
        "calculateScore": {
            "description": "Cuando rellene la encuesta de bienestar, sus respuestas serán analizadas usando miles de millones de variables de datos de personas de su edad y sexo. El cálculo también toma en cuenta la actividad que registras en %{programName}.\n\nTu puntuación de bienestar se actualiza periódicamente para que puedas ver cómo cambia con el tiempo."
        },
        "improveYourScore": "Mejorar tu puntuación"
    },
    "challengerCount": "%{num} de aspirantes",
    "team_name": "Nombre del equipo",
    "syncingDeviceToast": {
        "danger": {
            "message": "¡Uy! Tuvimos un problema sincronizando %{name}. Inténtalo nuevamente.",
            "title": "Sincronizar"
        },
        "success": {
            "title": "Sincronizar",
            "message": "Sincronizado exitosamente %{name}. Ahora tus actividades están al día."
        }
    },
    "allCompanyMembers": "Todos los miembros de la compañía",
    "allCompanyMembersTeam": "Todos los miembros de la compañía (Equipo)",
    "successfullyRedeemedItemForConfirmation": "Has canjeado este artículo exitosamente y se envió un correo electrónico de confirmación a %{email}.",
    "no_all_events_placeholder": "Parece que no hay eventos disponibles para unirse en este momento. ¿Por qué no creas uno?",
    "confirmDeleteAccount": "Confirma la eliminación introduciendo la dirección de correo electrónico asociada a tu cuenta",
    "deleteAccount": "Elimina la cuenta",
    "linkAccounts": "Administra las cuentas enlazadas",
    "titleSlug": {
        "icon_reward_text": "Para los miembros elegibles es fácil ganar más puntos si les compran a nuestros socios o en un chequeo con un dentista de Members' Choice Advantage usando tu cobertura extra.",
        "icon_move_text": "Monitorear opciones saludables diarias, como dormir mejor o comer vegetales, podría hacer que ganes Puntos Live Better(Vivir Mejor).",
        "icon_redeem_text": "Live Better (Vivir Mejor) recompensa a los miembros de Medibank que tienen cobertura hospitalaria o cobertura extra por cuidar su salud.",
        "icon_phone_text": "Inscríbete y sigue tu camino para canjear las recompensas, como tarjetas de regalo de salud y bienestar o ahorro en tu cobertura médica.",
        "wellness": "Bienvenido al mundo del bienestar",
        "goals": "Alcanza tus objetivos",
        "devices": "Mantente en el camino",
        "challenges": "Crea desafíos",
        "celebrate": "Bienestar social",
        "habits": "Construye hábitos saludables",
        "joinChallenge": "Únete al desafío",
        "getSocial": "Socialice",
        "reward": "Serás recompensado por vivir una vida más saludable.",
        "move": "Muévete, come y siéntete mejor.",
        "phone": "Vive mejor, siéntete mejor."
    },
    "viewProgress": {
        "goal": "Ver el progreso de los objetivos",
        "challenge": "Ver el progreso del desafío",
        "progress": "Ver el progreso"
    },
    "vitalStats": {
        "disclaimer": {
            "message": "Colocar esta información es opcional, para tu propio beneficio, y privado para ti."
        }
    },
    "eventBonusPoints": {
        "section": {
            "title": "¡Las bonificaciones %{potentialBonusPoints} %{customPoints} están disponibles para este evento!"
        },
        "modal": {
            "paragraph1": "Al asistir a este evento ganarás bonificaciones %{pointsName}.",
            "paragraph2": "Todos las bonificaciones %{pointsName} se otorgan después de que el evento haya culminado. No recibirás créditos de bonificación por los eventos a los que no asistas."
        }
    },
    "EAP": {
        "contactInfo": "Información de contacto",
        "doLater": "Lo haré más tarde",
        "tellMore": "Cuéntame más",
        "contactMe": "Contáctame",
        "title": "Programa de asistencia para empleados y familiares",
        "reachGoal": {
            "title": "La ayuda está disponible",
            "description": "Tu Programa de Asistencia a Empleados y Familias (EFAP), proporcionado por %{providerName}, ofrece una variedad de servicios de capacitación en salud que te ayudarán a alcanzar tus objetivos de bienestar.\n \n \n \n ¿Te gustaría que %{providerName} se comunique contigo para darte más información?"
        },
        "privacyPolicy": "%{provider} Política de privacidad"
    },
    "HRIS": {
        "disclaimer": "Algunos campos se actualizan automáticamente y no se pueden cambiar."
    },
    "settingGoals": {
        "description": "Enfocarte en 3 objetivos recomendados a la vez aumentará tus probabilidades de éxito.",
        "title": {
            "one": "Tienes 1 meta establecida"
        }
    },
    "auth": {
        "linkAccount": {
            "alreadyLinkedToUser": "Esta cuenta ya está enlazada con un usuario diferente",
            "lastAccountMessage": "¿Estás seguro de que quieres eliminar tu última cuenta enlazada? Una vez eliminada, debes iniciar sesión con la dirección de correo electrónico %{email} y una nueva contraseña.",
            "unlinkCorpAccountMessage": "¿Estás seguro de que quieres eliminar tu cuenta corporativa enlazada? Una vez eliminada, debes iniciar sesión con la dirección de correo electrónico %{email} nuevamente.",
            "alreadyLinked": "La cuenta ya está enlazada",
            "unlinkMessage": "¿Estás seguro de que quieres eliminar una cuenta enlazada?"
        },
        "sso": {
            "emailNotVerified": "Tu correo electrónico no está verificado."
        },
        "signIn": {
            "dontHaveAccount": "¿No tienes una cuenta?",
            "enterPIN": "Introduce el Número de Identificación del Programa de tu empresa",
            "dontKnowPIN": "¿No sabes tu PIN?",
            "pin": "PIN",
            "register": "Registrarse",
            "pinDescription": "Comunícate con el administrador del programa si no estás seguro del Número de Identificación de Programa (PIN) único de tu organización. Si tienes un PIN y tienes dificultades para proceder al siguiente paso, comunícate con support@sproutatwork.com.",
            "keepMeTooltip": "Para tu conveniencia, cuando esta casilla esté marcada, tu sesión será válida durante 30 días. Para los dispositivos compartidos, te recomendamos que se desmarques esta casilla y que cierres la sesión cuando hayas finalizado."
        },
        "signUp": {
            "backToLogin": "Volver al inicio de sesión",
            "termsOfService": "Condiciones del servicio",
            "privacyPolicy": "Política de privacidad"
        },
        "createYourAccount": "Crea tu cuenta",
        "setYourDetails": "Establece tus datos",
        "ModaHybridLogin": {
            "noAccessDashboard": "¿No tienes acceso al Panel de miembros?",
            "signUpSSOButton": "Regístrate a través del Panel de miembros de Moda",
            "noAccessDashboardWeb": "Si no tiene acceso al Panel de miembros, inicie sesión con su correo electrónico y contraseña a continuación.",
            "loginSSOButton": "Iniciar sesión a través del Panel de miembros de Moda"
        }
    },
    "entityHasBeenDeleted": "%{name} se ha eliminado",
    "track_challenge": {
        "message": {
            "manually": "Monitorear manualmente",
            "automatically": "Monitoreado automáticamente con %{appOrDeviceName}",
            "manuallyOrConnect": "Monitorear manualmente o conectar una aplicación o dispositivo",
            "manuallyAndBy": "Monitorear manualmente y automáticamente con %{appOrDeviceName}",
            "reconnectDevice": "Se requiere un dispositivo. Conecta tu dispositivo nuevamente",
            "manualAndAuto": "Regístrese para crear una cuenta.",
            "trackedAutomatically": "Monitoreado automáticamente"
        }
    },
    "signUpPartnerSSOToast": {
        "danger": {
            "title": "No puede registrarse",
            "message": "No pueden recuperarse los datos de usuario del socio. Inténtalo nuevamente más tarde"
        }
    },
    "app_device_required": {
        "disclaimer": {
            "title": "Se requiere una aplicación o dispositivo para este %{goalName}.",
            "subTitle": "Conecta una aplicación o dispositivo"
        }
    },
    "descriptionSlug": {
        "wellness": "Únete a la comunidad de la salud que te ayuda a fijar objetivos, conectarte y mantenerte en el camino.",
        "goals": "Cuéntanos en qué estás trabajando. Te ayudaremos a llegar allí con los objetivos recomendados.",
        "devices": "Sincroniza tu dispositivo de acondicionamiento físico o registra tus actividades y mantén tus objetivos de bienestar en el camino correcto.",
        "challenges": "Procura la competencia amistosa. Crea un desafío e invita a otros a unirse a la diversión.",
        "celebrate": "Mantente en contacto con tus colegas y celebren sus éxitos juntos.",
        "habits": "Monitorea las actividades de bienestar para ganar puntos. Enlázalo a tu teléfono o dispositivo para ganar más rápido.",
        "joinChallenge": "Observa cómo desafías a tus compañeros de trabajo en competencias amistosas.",
        "getSocial": "Mantente conectado con tus colegas y celebren sus éxitos juntos.",
        "reward_text": "Gana puntos por completar las actividades diarias y los desafíos personales.",
        "move_text": "Ya sea por un paseo alrededor de la manzana, por cinco minutos de concientización o por una racha de comida saludable, serás recompensado.",
        "phone_text": "Usa tus puntos para obtener descuentos en tu cobertura y grandes ofertas; la elección es tuya.",
        "none": ""
    },
    "core": {
        "featureNotEnabled": "Característica no activada",
        "checkAppVersion": {
            "message": "Parece que tu aplicación está desactualizada. Instala la última actualización.",
            "button": "Actualización %{appName}"
        },
        "noConnection": {
            "title": "No hay conexión de red",
            "description": "Parece que no estás conectado a Internet. No podrás usar la aplicación por completo a menos que tengas una conexión.",
            "button": "Inténtalo nuevamente"
        },
        "uploadPhotoText": "Agrega una foto para tu %{entityType}",
        "entities": {
            "community": "comunidad",
            "event": "evento",
            "team": "equipo",
            "goal": "objetivo",
            "challenge": "desafío",
            "competition": "competencia"
        }
    },
    "registration": {
        "login": {
            "errorHeading": "No se puede iniciar sesión",
            "resetPasswordHeading": "Restablecimiento de contraseña requerido"
        },
        "signup": {
            "corporateOrOther": "¿No eres miembro de Medibank? ¿O parte de un programa corporativo?",
            "sign_up_here": "Inscríbete aquí",
            "errorHeading": "No puede registrarse",
            "areYouMedibankMember": "¿Eres miembro de Medibank?",
            "isMedibankMember": "Soy miembro",
            "isNotMedibankMember": "No soy miembro"
        },
        "bpidExists": "El correo electrónico proporcionado ya está enlazado con un usuario live better (vive mejor); el correo electrónico debe ser único.",
        "generalError": "Servicio no disponible actualmente"
    },
    "rewardsNoAvailableProducts": "No hay productos disponibles en este momento.",
    "endedGoal": {
        "timeToTrack": {
            "yes": "¡Todavía tienes tiempo para monitorear!",
            "no": "Tu %{type} finalizó"
        },
        "grace": "Tu %{type} puede haber finalizado, pero tienes %{n} %{text} para monitorear cualquier actividad olvidada",
        "notGrace": {
            "goal": "¡Felicitaciones por completar tu objetivo! Continúa haciendo un gran trabajo fijando uno nuevo para mantenerte en el camino de tu bienestar.",
            "competition": "¡Felicitaciones por completar el desafío! Mantén tu impulso uniéndote a otro desafío o creando el tuyo propio."
        }
    },
    "appDeviceModal": {
        "defaultMessage": "Conecta tu dispositivo o aplicación y disfruta de un monitoreo perfecto. Tu autenticación permite a nuestro socio tecnológico \"Sprout\" transferir tus datos de forma segura desde tu cuenta %{appDeviceTitle}."
    },
    "noTransactionsMessage": "Parece que no has hecho ninguna transacción.",
    "noRedemptionsMessage": "Parece que aún no has hecho ningún canje.",
    "challengeCarousel": {
        "emptyChallenge": {
            "subtitle": "Puedes competir en el desafío como un individuo o como un equipo",
            "prompt": "No hay desafíos a los que unirse ahora mismo. ¿Por qué no creas uno?"
        },
        "createChallengeButton": "Crea un desafío"
    },
    "eventCarousel": {
        "emptyEvents": {
            "subtitle": "Los eventos pueden ser solo con invitación o abiertos a cualquiera.",
            "button": "Crea un evento"
        },
        "emptyEventsMessage": "No hay eventos a los que unirse ahora mismo. ¿Por qué no creas uno?"
    },
    "appnameLiveBetter": "Live Better (Vive mejor)",
    "appnameTelus": "Bienestar",
    "appnameUPnGo": "UPnGO (LEVÁNTATEyVE)",
    "personal_goal": {
        "carousel": {
            "headingNoSet": "¡No tienes ningún objetivo fijado!",
            "descriptionNoSet": "Mejora tu puntuación de bienestar fijando algunos objetivos. Empieza rápidamente con un objetivo recomendado, elige uno del catálogo o crea el tuyo propio.",
            "descriptionSet": "Puedes fijar uno de los objetivos recomendados que tenemos solo para ti, navegar por el catálogo completo o crear tu propio objetivo.",
            "action_text": "Fijar un nuevo objetivo",
            "heading_singular": "Puedes fijar 1 objetivo más",
            "heading_plural": "Puedes fijar %{number} objetivos más"
        },
        "heading": "Objetivos personales",
        "single": "Objetivo personal"
    },
    "settingGoal": {
        "yourGoal": "Tu %{units}",
        "yourGoalDescription": "¡Estás en camino! Las siguientes %{units} se pondrán en marcha y iniciarán de inmediato.",
        "selectedGoals": "Objetivos seleccionados",
        "recommendedDescription": {
            "maximumSet": "Tienes el número máximo de objetivos fijados. Puedes navegar y fijar nuevos objetivos después de que hayan finalizado los actuales.",
            "maximumSetTitle": "Tienes %{count} objetivos fijados"
        }
    },
    "activityLogRemoved": {
        "single": {
            "success": "La actividad ha sido eliminada",
            "info": "Algo salió mal. Inténtalo nuevamente.",
            "danger": "Algo salió mal. Inténtalo nuevamente."
        },
        "plural": {
            "success": "Las actividades han sido eliminadas",
            "info": "Algo salió mal. Inténtalo nuevamente.",
            "danger": "Algo salió mal. Inténtalo nuevamente."
        },
        "success": " ",
        "info": "La actividad no fue eliminada. Inténtalo nuevamente.",
        "danger": "La actividad no fue eliminada. Inténtalo nuevamente."
    },
    "participants": "Participante(s)",
    "members": "Miembro(s)",
    "timeSittingInformationOld": "Los lineamientos recomiendan:\n - Minimizar la cantidad de tiempo que se pasa sentado prolongadamente.\n - Interrumpir los periodos largos que pasa sentado tan a menudo como sea posible.",
    "timeSittingInformation": {
        "title": "Los lineamientos recomiendan:",
        "list": "- Minimizar la cantidad de tiempo que se pasa en una sesión prolongada.\n- Interrumpir los largos períodos sentado tan a menudo como sea posible."
    },
    "activityLevelInformationOld": "Los lineamientos recomiendan:\n - Estar activo la mayoría de los días de la semana, preferiblemente todos.\n - Acumular más de 150 minutos de actividad física de intensidad moderada cada semana.\n - Hacer actividades de fortalecimiento muscular al menos dos días a la semana.",
    "activityLevelInformation": {
        "title": "Los lineamientos recomiendan:",
        "list": "- Estar activo la mayoría de los días de la semana, preferiblemente todos.\n- Acumular más de 150 minutos de actividad física de intensidad moderada cada semana.\n- Hacer actividades de fortalecimiento muscular al menos dos días a la semana."
    },
    "viewGuidelines": "Ver lineamientos",
    "corporateAccountLink": {
        "verification": {
            "title": "Verifica tu dirección de correo electrónico del trabajo",
            "description": "Necesitarás verificar tu dirección de correo electrónico del trabajo para completar el proceso de enlace exitosamente. Sigue las instrucciones enviadas a:"
        }
    },
    "invitation": {
        "findFriendsAndFamily": "Encuentra amigos y familiares",
        "findFriends&Family": "Encuentra amigos y familiares",
        "tapToAddFriendsAndFamily": "Toca para agregar a tus amigos y familiares",
        "addedFriendsAndFamily": "Agregado a amigos y familiares",
        "whoYouAreLookingFor": "¿No ves a quién estás buscando?",
        "inviteWithEmail": "Invitar con el correo electrónico",
        "sentInvitations": "Envié invitaciones",
        "foundPerson": "Encontramos a esta persona con un correo electrónico que coincide",
        "youAreBoth": "Ambos están en %{entityName}",
        "youAreBothMore": "Ambos están en %{entityName}, +%{n} más",
        "noFriendsAndFamilyAdded": "Parece que aún no tienes ningún amigo o familiar agregado.",
        "sendInvitation": "Enviar invitación",
        "youHaveNoSentInvitations": "No has enviado ninguna invitación",
        "toast": {
            "success_title": "Invitación enviada",
            "success_description": "%{invite_email} verás la invitación en tu bandeja de entrada",
            "danger_title": "La invitación no fue exitosa",
            "danger_description": "Inténtalo nuevamente más tarde"
        },
        "email": {
            "invalid_email": "Introduce una dirección de correo electrónico válida"
        },
        "inviteOthers": "Invitar a otros",
        "searchForSomeone": "Buscar a alguien",
        "searchForOthersToInvite": "Busca a otros para invitarlos",
        "programNameOnly": {
            "title": "%{programName} solo",
            "description": "Este %{entityType} solo está disponible para las personas que son parte de %{programName}"
        },
        "domainCannotBeUsed": "Este dominio no puede usarse con %{programName}",
        "actionSearchByEmail": "Envía una invitación por correo electrónico si no puedes encontrar a quien estás buscando",
        "send": "Enviar",
        "addEmailToList": "Agregar correo electrónico a la lista",
        "toBeSent": "Invitaciones para enviar",
        "noInvitationsToBeSent": "No hay invitaciones",
        "removeEmailConfirmation": "¿Estás seguro de que quieres eliminar este correo electrónico de la lista?",
        "yes": "Sí",
        "no": "No",
        "foundByEmail": "Encontramos a esta persona con un correo electrónico que coincide",
        "addToFriendsAndFamily": "Agregar a amigos y familiares",
        "alreadyAddedEmail": "Ya has agregado este correo electrónico a la lista"
    },
    "pointsCurrencyAdditionalInfo": "Tus %{points_name} y los niveles empiezan nuevamente cada %{period}. Todas tus actividades monitoreadas contribuyen con tu nivel general en el período.",
    "rankLabel": "Rango",
    "leaderboards": {
        "loadingLabel": "Cargando las tablas de clasificación... Esto puede demorar unos minutos, ¡parece que todo el mundo está afuera activándose!"
    },
    "feeds": {
        "emptyListHomePage": "No hay publicaciones todavía. Intenta ajustar el muro para mostrar más publicaciones.",
        "viewingPostsFrom": "Viendo las publicaciones de",
        "postActivity": "¡Agrega un comentario o una foto sobre tus actividades!",
        "indicatorLoader": {
            "defaultTitle": "Actualizando...",
            "successfulLoadedTitle": "Sincronizado y actualizado..."
        },
        "inapropriateTextError": {
            "message": "El contenido de tu mensaje puede ser inapropiado. Intenta usar un lenguaje más amigable."
        },
        "postImageError": {
            "title": "Lo siento, no podemos publicar esto",
            "message": "La imagen que agregaste puede ser inapropiada. Prueba con otra."
        }
    },
    "syncModal": {
        "connect": {
            "title": "Conectando %{name}",
            "description": "Para conectar tus datos %{name} con tu cuenta, completa los siguientes pasos:",
            "firstStep": "Descarga e instala la aplicación móvil de %{appName} desde el %{storeName}",
            "fourthStep": "Selecciona para conectar con %{name}",
            "fifthStep": "Cuando se te indique, selecciona la métrica de salud para sincronizar con %{appName} y presiona 'Listo'.",
            "additionalInfo": "Considera que para activar la sincronización de la aplicación de Salud %{appName} debe estar abierto. Aunque no es necesario mantener la aplicación abierta, la sincronización puede demorar una hora en completarse y aparecer en el registro de actividades."
        },
        "title": "Sincronización %{name}",
        "description": "Completa los siguientes pasos para sincronizar tus datos %{name} con tu cuenta:",
        "steps": {
            "one": "Accede a tu aplicación %{appName} en tu teléfono",
            "two": "Abre la sección de Aplicaciones y Dispositivos en tu perfil",
            "three": "Presiona el botón de sincronización junto a %{name}",
            "iPhone": "Accede a tu aplicación %{appName} en tu iPhone"
        }
    },
    "accountLinkingToast": {
        "success": {
            "title": "Cuenta de trabajo",
            "message": "Cuenta conectada exitosamente"
        },
        "danger": {
            "message": "Error de conexión de la cuenta"
        },
        "conflict": {
            "message": "Cuenta enlazada con un usuario diferente"
        }
    },
    "accountUnlinkingToast": {
        "success": {
            "title": "Cuenta de trabajo",
            "message": "Cuenta desconectada exitosamente"
        },
        "danger": {
            "title": "Cuentas de enlace",
            "message": "Error al desconectar la cuenta"
        }
    },
    "earnMoreWithPartners": "Gana más con los socios",
    "connectPartnersToEarnByShopping": "Conecta tus cuentas y gana más %{unit_type} comprando con %{program_name} socios.",
    "viewAllPartners": "Ver todos los socios",
    "myPartnerMemberships": "Mis membresías de socio",
    "linkAccount": "Membresía de enlace",
    "linkToPartner": "Enlace al socio",
    "linkingError": "Hubo un problema al enlazar tu cuenta. Inténtalo nuevamente.",
    "linkPending": "Enlace pendiente",
    "unlinkAccount": "Desenlazar la cuenta",
    "linkedToPartnerName": "Enlazado a %{partner_name}",
    "linked": "Enlazado",
    "permission": {
        "facebookTitle": "Regístrate en Facebook",
        "googleTitle": "Regístrate en Google",
        "facebookDescription": "Cuando te registres en Facebook tendrás que dar permiso a nuestro socio tecnológico \"Sprout\" para que acceda a tu identidad y cree tu cuenta %{programName}.",
        "googleDescription": "Cuando te registres en Google tendrás que dar permiso a nuestro socio tecnológico \"Sprout\" para que acceda a tu identidad y cree tu cuenta %{programName}.",
        "camera": {
            "title": "Acceso a la cámara",
            "description": "Se requiere acceso a la cámara para tomar una foto. En la configuración del iPhone, toca %{appName} y enciende la Cámara.\n \n \n \n Considera que puedes perder cualquier cambio no guardado."
        },
        "notNow": "Ahora no",
        "openSettings": "Abrir la configuración",
        "photos": {
            "title": "Permite el acceso a las fotos",
            "description": "Esto te permite compartir fotos de tu biblioteca y guardarlas en tu rollo fotográfico. En la configuración del iPhone, toca %{appName} y cambia Fotos a Lectura y escritura.\n \n \n \n Considera que puedes perder cualquier cambio no guardado."
        }
    },
    "firstNameContainsSpecialChar": "Tu nombre solo puede contener letras inglesas, guiones y apóstrofes.",
    "lastNameContainsSpecialChar": "Tu apellido solo puede contener letras inglesas, guiones y apóstrofes.",
    "goToPartnerSite": "Ir a la página de socios",
    "noPartnersFound": "No se han encontrado socios",
    "noLinkedPartners": "No hay socios enlazados",
    "noPartnersInCategory": "No hay socios en la categoría",
    "partnerAccountPendingVerification": "La verificación de la cuenta está pendiente",
    "shopWithPartner": "Comprar con un socio",
    "shopWithPartnerName": "Compra con %{partner_name}",
    "linkToPartnerName": "Enlace a %{partner_name}",
    "earnPartnerMembershipIdentifier": "Identificador de miembros",
    "earnPartnerAccountPendingAddLink": "Tu membresía se está enlazando y puede demorar varios días para completarse.",
    "earnPartnerAccountPendingRemoveLink": "Tu membresía se está desvinculando y puede demorar varios días para completarse.",
    "linkStatusUpdating": "Actualización del estado del enlace",
    "activityTracking": {
        "firstActivityModal": {
            "description1": "¡Felicitaciones por agregar tus primeras actividades! \n \n Si quieres, puedes agregar más actividades para hoy y otros días. Cuando finalices con las actividades de hoy, toca",
            "description2": "en la siguiente pantalla cuando no tengas nada más que monitorear."
        },
        "listTitle": "Actividades monitoreadas en",
        "dots": {
            "tracked": "Las actividades monitoreadas en este día",
            "added": "Las actividades han sido agregadas y están pendientes para enviarse"
        },
        "trackedActivitiesFor": "Actividades de monitoreo para %{date}",
        "activityTracking": "Monitoreo de la actividad",
        "addedPending": "Agregado (envío pendiente)",
        "search": {
            "description1": "Toca",
            "description2": "para ver las actividades disponibles o buscar una actividad específica"
        },
        "addActivity": "Agrega la actividad",
        "addAnotherActivity": "Agrega otra actividad"
    },
    "rewardsBalance": "Saldo en %{currencyName}: %{points}",
    "membershipIdentifierRequiredError": "Tu identificador de miembro es necesario para enlazar",
    "incorrectValueInRange": "Introduce un valor entre %{min} y %{max}",
    "joinTeam": {
        "title": "Únete al equipo",
        "createInsteadText": "Únete o crea un equipo para participar en este desafío"
    },
    "teamRank": "Rango del equipo",
    "teamScore": "Puntuación del equipo",
    "appsDevices": {
        "infoText": "Se te pedirá que autorices a nuestro socio tecnológico Sprout Wellness Solutions, Inc. para acceder a los datos de tu bienestar cuando agregues una aplicación o un dispositivo.",
        "connectModal": {
            "title": "Autorización",
            "paragraph1Part1": "Se te pedirá que autorices a nuestro socio tecnológico",
            "paragraph1Part2": "Sprout Wellness Solutions, Inc.",
            "paragraph1Part3": "para acceder a tus datos de bienestar.",
            "paragraph2Desc1": "¡Tu autorización permite que",
            "paragraph2Desc2": "Sprout",
            "paragraph2Desc3": "sincronice tus datos",
            "paragraph2Desc4": "de forma segura",
            "paragraph2Desc5": "y te ayuda a ganar más %{pointsName}!"
        },
        "statusAlert": {
            "connectMessage": "Conecta un dispositivo de monitoreo de aplicación o de actividad y haz que la actividad se sincronice y monitoree fácilmente",
            "connectAction": "Conecta una aplicación o dispositivo",
            "errorMessage": "Algunas de las aplicaciones o dispositivos conectados no pueden sincronizarse",
            "warningMessage": "Algunas de las aplicaciones o dispositivos conectados pueden tener un problema de conexión",
            "errorAction": "Arreglar este error",
            "warningAction": "Arreglar esta advertencia",
            "syncingError": "Error de sincronización",
            "syncingIssue": "Problema de sincronización"
        },
        "deviceDetails": {
            "warningMessage": "Esta aplicación o dispositivo tiene problemas para sincronizarse",
            "errorMessage": "Esta aplicación o dispositivo no puede sincronizarse",
            "warningAction": "Descarta la advertencia",
            "noActivities": "No hay actividades sincronizadas de %{deviceName} con el programa %{programName} en los últimos 7 días. \n \n \n Puede demorar hasta una hora para que las actividades aparezcan aquí después de que %{deviceName} las monitoree.\n \n \n \n Si tienes otra aplicación o dispositivo conectado y se han monitoreado más pasos a través de la otra aplicación o dispositivo, verás la actividad allí. De lo contrario, intenta desconectar y reconectar %{deviceName}. Si se te pide que autentiques o concedas permisos, asegúrate de que estás habilitando los datos de actividad y que estás utilizando la misma cuenta de autenticación que la utilizada para realizar el monitoreo de las actividades. Consulta los pasos de solución de problemas para obtener más información."
        },
        "troubleshooting": "Solución de problemas",
        "deviceItem": {
            "error": "Error de conexión",
            "warning": "Advertencia de conexión",
            "unableToSync": "No puede sincronizarse"
        },
        "platformDevice": {
            "defaultApp": "La aplicación de salud por defecto de tu dispositivo es",
            "continueMore": "Continuar con más aplicaciones y dispositivos"
        }
    },
    "friendsAndFamily": {
        "learnMore": "Aprende más sobre los amigos y la familiares",
        "learnModal": {
            "title": "Acerca de los amigos y la familiares",
            "description": "Después de agregar a alguien a tus amigos y familiares, puedes elegir compartir tus publicaciones en %{programName} solo con ellos.\n \n \n \n También puedes filtrar las publicaciones que ves en %{programName} solo para las personas de tu lista de amigos y familiares si han publicado para todos o para ti.",
            "description_line1": "Después de agregar a alguien a tus amigos y familiares, puedes elegir compartir tus publicaciones en %{programName} solo con ellos.",
            "description_line2": "También puedes filtrar las publicaciones que ves en %{programName} solo para las personas de tu lista de amigos y familiares si han publicado para todos o para ti.",
            "whatIconsMean": "Qué significan los iconos",
            "canAdd": "Agregar",
            "added": "Agregado"
        },
        "searchDescription1": "Busca personas para agregar a tus amigos y familia.",
        "searchDescription2": "¿No ves a quién estás buscando? Envíales una invitación por correo electrónico para que se unan.",
        "friends&Family": "Amigos y familiares",
        "managingTour": {
            "title": "Administrar a los amigos y a la familia",
            "body": "Si deseas eliminar a alguien de tus amigos y familiares, toca el ícono"
        },
        "removeOption": "Eliminar de los amigos y familiares",
        "inviteDescription1": "Busque a sus amigos y familiares.",
        "inviteDescription2": "¿No ves a quién estás buscando?"
    },
    "deletePlatformInvitationToast": {
        "success": {
            "message": "Las publicaciones que compartas solo con amigos y familiares ya no serán visibles para %{userFirstName}."
        }
    },
    "skipAll": "Saltar todo",
    "smallMin": "min",
    "eap": {
        "skipModal": {
            "title": "¿Estás seguro?",
            "description": "Siempre puedes contactar al Programa de Asistencia para Empleados y Familias desde tu perfil cuando lo necesites."
        },
        "contact": {
            "whatIsBestNumber": "¿Cuál es el mejor número para contactarte?",
            "whatIsBestTime": "¿Cuál es la mejor hora para contactarte?",
            "morning": "Mañana",
            "afternoon": "Tarde",
            "evening": "Noche",
            "additionalDetails": "Detalles adicionales sobre la hora\/fecha en que deseas que nos pongamos en contacto contigo",
            "message": "Contáctame el %{weekDay} al %{phoneNumber}. Información adicional: %{additional}",
            "description": "Nota: Recomendamos encarecidamente que elijas una hora fuera de tu horario de trabajo y que optes por un lugar donde puedas tener una conversación privada. Incluye tu zona horaria."
        },
        "phoneNumber": {
            "empty": "Este campo no puede estar vacío",
            "missingDigits": "El número de teléfono debe contener al menos 4 dígitos"
        },
        "myEAP": "Mi programa de asistencia a empleados y familiares"
    },
    "healthSurveySkipAllTitle": "Saltar la encuesta sobre el bienestar",
    "healthSurveySkipAllAlert": "¿Estás seguro de que te gustaría saltarte todas las preguntas restantes de la encuesta sobre el bienestar?",
    "eapSavingWithoutDataToast": {
        "danger": {
            "title": "Programa de asistencia al empleado y a los familiares",
            "message": "Proporciona tu número telefónico y la mejor hora para contactarte"
        }
    },
    "allMyChallenges": "Mis desafíos",
    "invitedChallenges": "Invitaciones",
    "companyChallenges": "Los desafíos de la compañía",
    "completedChallengesEmpty": "Parece que no has completado ningún desafío todavía.",
    "myChallengesEmpty": "Parece que no te has unido a ningún desafío todavía.",
    "allChallengesEmpty": "No hay desafíos.",
    "startsToday": "Inicia hoy",
    "startedDaysAgo": "Empezó hace %{dayCount} días",
    "startsInDays": "Inicia en %{dayCount} días",
    "privacyOn": "Desactivado",
    "privacyOff": "Activado",
    "dashboard": {
        "viewLeaderboard": "Ver la tabla de clasificación",
        "timePeriodProgress": "Tu progreso este %{period}",
        "howToEarn": "Cómo ganar puntos"
    },
    "privacyChangeConfirmationMessage": "¿Cambiar la privacidad?",
    "privacySettingsTitle": "Privacidad",
    "privacySettingsDescription": "Puedes controlar la visibilidad de tu foto, nombre y perfil para otros usuarios.",
    "mainLeaderBoardSettingsTitle": "?Tabla de clasificación general",
    "challengeLeaderBoardSettingsTitle": "?Tabla de clasificación de los de los desafíos",
    "managePrivacySettingUrlTitle": "Administrar la configuración de la privacidad",
    "onboardingFamilyPrivacySettingsMessageOn": "Estás visible en los resultados de búsqueda de amigos y familiares. Puedes elegir ocultarte de los resultados de la búsqueda.",
    "onboardingFamilyPrivacySettingsMessageOff": "Tu configuración de privacidad te oculta actualmente en los resultados de búsqueda de amigos y familiares.",
    "challengeInvitationPrivacySettingsMessageOn": "Estás visible en los resultados de búsqueda de invitaciones a participar en concursos. Puedes elegir ocultarte de los resultados de búsqueda.",
    "challengeInvitationPrivacySettingsMessageOff": "Tu configuración de privacidad te oculta actualmente en los resultados de búsqueda de invitaciones a participar en concursos.",
    "challengeParticipationPrivacySettingsMessageOn": "Apareces como participante en este desafío. Puedes elegir ocultarte como participante de tus desafíos.",
    "challengeParticipationPrivacySettingsMessageOff": "Tu configuración de privacidad te oculta actualmente de la lista de participantes.",
    "communityInvitationPrivacySettingsMessageOn": "Estás visible en los resultados de búsqueda de invitaciones de la comunidad. Puedes elegir ocultarte de los resultados de búsqueda.",
    "communityInvitationPrivacySettingsMessageOff": "Tu configuración de privacidad te oculta actualmente de los resultados de búsqueda de invitaciones a la comunidad.",
    "communityParticipationPrivacySettingsMessageOn": "Apareces como miembro de esta comunidad. Puedes elegir ocultarte como miembro de tus comunidades.",
    "communityParticipationPrivacySettingsMessageOff": "Tu configuración de privacidad te oculta actualmente de la lista de miembros.",
    "eventInvitationPrivacySettingsMessageOn": "Estás visible en los resultados de búsqueda de invitaciones a eventos. Puedes elegir ocultarte de los resultados de búsqueda.",
    "eventInvitationPrivacySettingsMessageOff": "Tu configuración de privacidad te oculta actualmente de los resultados de búsqueda de invitaciones a eventos.",
    "eventParticipationPrivacySettingsMessageOn": "Apareces como participante de este evento. Puede elegir ocultarse como participante de tus eventos.",
    "eventParticipationPrivacySettingsMessageOff": "Tu configuración de privacidad te oculta actualmente de la lista de participantes.",
    "mainLeaderboardPrivacySettingsMessageOn": "Aparecerás en las tablas de clasificación generales. Puedes elegir ocultarte, lo que eliminará tu rango, imagen y nombre cuando otros vean las tablas de clasificación general.",
    "mainLeaderboardPrivacySettingsMessageOff": "Tu configuración de privacidad te oculta actualmente cuando otros ven las tablas de clasificación general.",
    "challengeLeaderboardPrivacySettingsMessageOn": "Aparecerás en las tablas de clasificación de los desafíos. Puedes elegir ocultarte, lo que eliminará tu rango, imagen y nombre cuando otros vean las tablas de clasificación de los desafíos.",
    "challengeLeaderboardPrivacySettingsMessageOff": "Tu configuración de privacidad te oculta cuando otros ven las tablas de clasificación de los desafíos.",
    "thumbsUpConfirmationTitle": "Me gusta",
    "thumbsUpConfirmationDescriptionline1": "¡Felicitaciones, estás a punto de darle me gusta y animar a alguien por primera vez!",
    "thumbsUpConfirmationDescriptionline2": "Serás incluido en la lista de personas a las que les ha gustado esta publicación y otros podrán ver tu foto, nombre y perfil.",
    "thumbsUpConfirmationButtonOk": "Me gusta",
    "commentToActionInfoTitle": "¿Qué ven los demás?",
    "commentToActionMessage": "Cuando comentas, los demás pueden ver tu foto, nombre y tu perfil.",
    "postToActionTitle": "¿Quién ve esta publicación?",
    "postToActionMessageLine1": "Cuando creas una publicación puedes controlar quién tiene acceso e incluso publicarla solo para ti.",
    "postToActionMessageLine2": "Las publicaciones que compartas con otros mostrarán tu foto, nombre y perfil.",
    "privateUsersDescriptionChallenge": "Este(os) participante(s) se ha(n) escondido de la lista",
    "privateUsersFirstNamePlaceHolderChallenge": "%{n} privado",
    "privateUsersLastNamePlaceHolderChallenge": "participante(s)",
    "privateUsersDescriptionEvent": "Este(os) asistente(s) se ha(n) escondido de la lista",
    "privateUsersFirstNamePlaceHolderEvent": "%{n} privado",
    "privateUsersLastNamePlaceHolderEvent": "asistente(s)",
    "privateUsersDescriptionCommunity": "Este(os) miembro(s) se ha(n) escondido de la lista",
    "privateUsersFirstNamePlaceHolderCommunity": "%{n} privado",
    "privateUsersLastNamePlaceHolderCommunity": "miembro(s)",
    "noPrivacySettings": "No hay configuraciones de privacidad",
    "linkToPartnerNameWebsite": "Enlace a través del sitio web de %{partner_name}",
    "linkToPartnerWebsiteUrl": "URL del sitio web del socio",
    "start_end_time": "Hora de inicio y fin:",
    "joinCreateTeamPrivacyDisclaimer": "Tu foto, nombre y perfil siempre estarán visibles para cualquiera que vea a tu equipo en un desafío, incluso si has cambiado tu Configuración de Privacidad a Privada.",
    "carouselInstructions": {
        "swipe": "Pasa las tarjetas para ver todos tus objetivos y desafíos.",
        "click": "Haz clic en las tarjetas para ver todos tus objetivos y desafíos."
    },
    "achieved": "Logrado",
    "hours": "horas",
    "createCommunityFlow": {
        "navigatorTitle": "Crear una comunidad",
        "stepType": {
            "title": "Visibilidad de la comunidad",
            "subTitle": "¿Quién podrá ver y unirse a la comunidad?",
            "privateName": "Privado",
            "publicName": "Público",
            "privateDescription": "Solo las personas que invites podrán ver o unirse a la comunidad",
            "publicDescription": "Cualquiera puede ver y unirse a esta comunidad"
        },
        "stepName": {
            "title": "Nombra tu comunidad",
            "subTitle": "Nombra a tu comunidad de manera que le permitas a las personas saber de qué se trata.",
            "namePlaceholder": "Nombre de la comunidad",
            "noFieldsTitle": "Nombre",
            "noFieldsMessage": "No se da ningún nombre"
        },
        "stepDescription": {
            "title": "Sobre tu comunidad",
            "subTitle": "Diles a los demás de qué se trata tu comunidad.",
            "descriptionPlaceholder": "Descripción (opcional)",
            "noFieldsTitle": "Descripción",
            "noFieldsMessage": "No se da ninguna descripción"
        },
        "stepImage": {
            "uploadPhotoButtonTitle": "Agrega una foto"
        },
        "stepJoin": {
            "title": "Encontramos comunidades similares",
            "subTitle": "¿Te gustaría unirte a una de estas comunidades en su lugar?"
        },
        "createNew": "Crear una nueva comunidad"
    },
    "challengeCard": {
        "allActivities": "Todas las actividades en la",
        "category": "categoría"
    },
    "myLinkedPartners": "Mis socios enlazados",
    "leaderboardPosition": "Posición en la tabla de clasificación general",
    "remainingInChallenge": "que se mantiene en el desafío",
    "todays_progress": "El progreso de hoy",
    "this_weeks_progress": "El progreso de esta semana",
    "this_months_progress": "El progreso de este mes",
    "achievement": "logro",
    "challengeCardHeader": {
        "challenge": "Desafío",
        "recommended_personal_goals": "Objetivo personal recomendado",
        "personal_goal": "Objetivo personal",
        "competition": "Concurso",
        "recommended_goals": "Objetivo recomendado",
        "team_competition": "Competencia por equipos",
        "team": "Equipo"
    },
    "MyMedibank": "Mi Medibank",
    "Google": "Google",
    "Facebook": "Facebook",
    "errorEntityTimeMessage": "La hora final no puede ser anterior a la hora de inicio",
    "company": "Compañía",
    "lessThan1DayRemain": "menos de 1 día",
    "lessThan1HourRemain": "menos de 1 hora",
    "remainingToday": "el resto del día de hoy",
    "periodEndsDateAndTime": "El período finaliza el %{date}, a las %{time}",
    "moreToGo": "%{n} más %{unit} para ir de",
    "reachedYourGoal": "¡Has alcanzado el objetivo de %{period}!",
    "reachedYourGoalToday": "¡Hoy alcanzaste tu objetivo!",
    "editProfileItemCorrectRange": "Coloca un valor de %{itemName} válido entre el valor mínimo %{min} y el valor máximo %{max}",
    "invalidUrl": "URL inválido",
    "activityLogChanged": {
        "success": "Los cambios en la actividad se han guardado",
        "info": "Algo salió mal... Inténtalo nuevamente.",
        "danger": "Algo salió mal... Inténtalo nuevamente."
    },
    "discardAlert": {
        "createChallenge": "¿Estás seguro de que quieres descartar este %{challengeType}?",
        "inviteByEmail": "¿Estás seguro de que quieres descartar los cambios?",
        "createTeam": "¿Estás seguro de que deseas cancelar la creación de este equipo?",
        "cancel": "Cancelar",
        "confirm": "Sí, descartar"
    },
    "entityInvalidNameError": "El nombre de la %{entity} debe contener solo números o el valor de la serie y no puede estar vacío",
    "accept": "Aceptar",
    "sync_now": "Sincronizar ahora",
    "reconnect_device": "Volver a conectar",
    "supported_activities": "Actividades apoyadas",
    "recentlySynced_activity": "Actividad sincronizada recientemente",
    "noSyncedActivity_sevenDays": "No han sido sincronizadas las actividades en los últimos 7 días",
    "recentActivityLog": {
        "convertingActivityPoints": "Sincronizando las actividades...",
        "activityMinuteOrTwo": "Esto puede demorar un minuto o dos...",
        "noNewActivities": "No se agregaron actividades nuevas... Puede demorar hasta una hora para que las actividades nuevas se sincronicen."
    },
    "deleteCommunityCheckbox": "Entiendo que esto no se puede deshacer",
    "createEvent": {
        "type": {
            "company": "Evento de la compañía",
            "user": "Evento de usuario",
            "title": "Tipo de evento"
        },
        "privacy": "Privacidad (mostrar a los asistentes o no)",
        "cost": "Costo",
        "associated": {
            "location": "Ubicación asociada",
            "department": "Departamento \/ Divisiones Asociado"
        },
        "maxParticipants": "Max. de participantes (opcional)",
        "errorMessage": {
            "limit": "No puede ser mayor que %{maxValue}",
            "negative": "No puede ser un valor negativo",
            "selectedLocations": "Seleccione uno o más lugares"
        },
        "selectLocations": "Lugares seleccionados",
        "createNew": "Crear un nuevo evento"
    },
    "selected": "Seleccionado",
    "deleteEventButton": "Eliminar este evento",
    "notification": {
        "priorityNotification": {
            "title": "Tiene actualizaciones importantes no leídas",
            "subtitle": "Toca para leerlos ahora",
            "subtitleWeb": "Haz clic para leerlos ahora"
        },
        "sectionTitle": {
            "priorityUnread": "Actualizaciones importantes no leídas",
            "all": "Todas las notificaciones"
        },
        "modalTitle": "Tienes %{count} actualizaciones importantes",
        "priorityModalTitle": {
            "defaultTitle": "Ver todas las actualizaciones"
        }
    },
    "createEntity": {
        "cancel": {
            "title": "Cancelar %{entity} %{actionType}",
            "message": "¿Estás seguro de que quieres cancelar %{entity} %{actionType}?"
        },
        "action": {
            "creating": "creando",
            "editing": "editando"
        },
        "type": {
            "team": "equipo",
            "community": "comunidad",
            "event": "evento",
            "challenge": "desafío",
            "goal": "objetivo"
        }
    },
    "publicVisibilitySwitch": {
        "modalTitle": {
            "public": "¿Hacerlo público?",
            "private": "¿Hacerlo privado?"
        },
        "modalSubtitle": {
            "public": "Hacer %{entityType} público lo abrirá a todos para que lo descubran y se unan. ¿Estás seguro de que quieres hacer %{entityType} público?",
            "private": "Hacer %{entityType} privado no permitirá que nadie lo descubra y se una. ¿Estás seguro de que quieres hacer %{entityType} privado?"
        },
        "footerButton": {
            "makePublic": "Sí, hacerlo público",
            "makePrivate": "Sí, hacerlo privado",
            "keepPrivate": "Mantenerlo privado",
            "keepPublic": "Mantenerlo público"
        },
        "label": {
            "title": "Publica este(a) %{entityType}",
            "subtitle": "Todo el mundo puede verlo y unirse"
        }
    },
    "imageUploader": {
        "changeImageButton": "Cambiar la imagen"
    },
    "copyright": "Derechos de autor © Sprout 2019",
    "samsunghealth_not_available": "No puede conectarse con Samsung Health. En la aplicación de Salud, en Permisos de Datos, asegúrate de tener al menos un permiso habilitado para los pasos y al menos 1 paso monitoreado.",
    "rewardsHowDoIEarn": "¿Cómo gano %{currencyName}?",
    "unlockAchievements": "Desbloquea los logros",
    "unlockAchievementsDescription": "Monitorea las actividades, gana %{pointsName}, desbloquea los niveles y gana más %{currencyName}. Toca cada logro para ver lo que necesitas hacer.",
    "myDay": "Mi día",
    "myGoalsChallengesTasks": "Mis objetivos, desafíos y tareas",
    "yourGoalsChallenges": "Tus objetivos y desafíos",
    "mySocialStream": "Publicaciones de la comunidad",
    "viewAllAchievements": "Ver todos los logros",
    "viewAllBonusChallenges": "Ver todos los desafíos de bonificación",
    "newVersionOfAppAvailable": "¡Nueva versión disponible! Recarga esta página",
    "noBonusChallengesToDisplay": "Actualmente no hay desafíos adicionales disponibles.",
    "bonusChallenges": "Desafíos de bonificación",
    "reloadAppVersion": "Recarga",
    "appname": "Sprout",
    "cancel_tracking_confirmation": "¿Estás seguro de que quieres eliminar el monitoreo %{activity_name}?",
    "activity_tracker_instruction_header": "Toca un día para monitorear las actividades de ese día o verifica lo que ya se ha monitoreado.",
    "alertDashboardFunctionalityToBeAdded": "el texto se agregará aquí para explicar lo que es un período de monitoreo. Esto es similar a lo que se hace con los programas de lealtad de las aerolíneas, en donde los usuarios necesitan seguir acumulando \"millas\" en un año calendario para obtener el estado para el próximo año.",
    "noNumberEntered": "Introduce la cantidad de actividad",
    "feed": "Muro",
    "home": "Inicio",
    "challenges": "Desafíos",
    "explore": "Explora",
    "rewards": "Recompensas",
    "reward": "recompensa",
    "balance": "Mi %{programName} recompensa el equilibrio",
    "profile": "Perfil",
    "loading": "Cargando...",
    "me": "Yo",
    "back": "Volver",
    "next": "Siguiente",
    "skip": "Saltar",
    "signup": "Registrarse",
    "signin": "Iniciar sesión",
    "signin_maintitle": "Sprout",
    "signin_subtitle": "",
    "signinto": "Inicia sesión en Live Better (Vive Mejor)",
    "signup_with_medibank": "Regístrate como un miembro de Medibank",
    "signup_with_facebook": "Regístrate en Facebook",
    "signup_with_google": "Regístrate en Google",
    "signup_with_email": "Regístrate con el correo electrónico",
    "signin_with_medibank": "Inicia sesión usando My Medibank",
    "signin_with_facebook": "Inicia sesión con Facebook",
    "signin_with_google": "Inicia sesión con Google",
    "signin_with_email": "Inicia sesión con el correo electrónico",
    "signup_heading": "Crear una cuenta",
    "not_a_medibank_member": "¿No eres miembro de Medibank?",
    "keep_me_signed_in": "Mantenme conectado",
    "forgotpassword": "¿Olvidaste tu contraseña?",
    "emailaddress": "Dirección de correo electrónico",
    "password": "Contraseña",
    "enterEmailAddress": "Coloca tu dirección de correo electrónico",
    "enterYourPassword": "Coloca tu contraseña",
    "password_for_error": "contraseña",
    "reset_password": "Restablecer la contraseña",
    "passwordResetSuccess": "Restablecimiento de contraseña",
    "passwordResetEmailSent": "Si tenemos una dirección de correo electrónico igual registrada en nuestro sistema, entonces se te enviaron las instrucciones para restablecer tu contraseña",
    "loginerror": "Se ha producido un error al iniciar la sesión:",
    "logincancelled": "Inicio de sesión cancelado",
    "part_of_corporate_program": "¿Te estás registrando en un programa corporativo?",
    "continue_here": "Continúa aquí",
    "program_name": "Nombre del programa",
    "error_provide_program_name": "Coloque el nombre del programa.",
    "program_not_found": "Programa no encontrado",
    "registration_field_email": "Correo electrónico",
    "employeeId": "Identificación del empleado",
    "registration_field_firstName": "Primer nombre",
    "registration_field_lastName": "Apellido",
    "no_first_name": "Sin nombre",
    "no_last_name": "Sin apellido",
    "registration_field_password": "Nueva contraseña",
    "no_disclaimer_available": "¡Uy! Ha habido un problema... No pudimos recuperar los términos y condiciones de tu organización. Intenta registrarte nuevamente más tarde.",
    "registration_account_not_registered": "Parece que aún no has verificado tu dirección de correo electrónico. ¿Quiere que te reenviemos el correo electrónico?",
    "resend_verification_email": "Verificación del correo electrónico",
    "resend_verification_email_successful": "Hemos reenviado tu correo electrónico de verificación.",
    "resend_verification_email_unsuccessful": "¡Uy! Ha habido un problema... no hemos podido reenviar el correo electrónico de verificación. Inténtalo nuevamente.",
    "not_supported": "Esta publicación no puede mostrarse ahora mismo. Inténtalo nuevamente más tarde.",
    "policyAgreeError": "Para continuar, acepta los Términos de servicio y la Política de Privacidad.",
    "challenge_completion_bonus": "Bonificación por completación",
    "me_tabs": {
        "activity": "Actividad",
        "bookmarks": "Marcadores"
    },
    "health_tab": {
        "my_health_score": "Tu puntuación de bienestar",
        "overall_health_score_description": "Tu puntuación de bienestar es",
        "health_score_explanation": "Tu puntuación de bienestar se calcula en base a tus respuestas sobre tu salud y tu nivel de actividad. \n \n \n \n Tu puntuación se actualiza cada mes en función de tus niveles de actividad. Puedes fijar y completar objetivos personales para mejorar tu puntaje de bienestar.",
        "health_score_calculation_failed_onboarding": "Algo salió mal y no hemos podido recuperar tu puntuación de bienestar. Puedes proceder por ahora y tan pronto como el problema se solucione, actualizaremos tu puntuación."
    },
    "track_activity": "Monitorear la actividad",
    "track_an_activity": "Monitorear una actividad",
    "track": "Monitorear",
    "unable_to_track": "No puede monitorearse",
    "enter_before_track": "Introduce la cantidad de actividad a monitorear",
    "what_to_share": "¿Qué tipo de actualización te gustaría compartir?",
    "remove": "Eliminar",
    "activity_tracking_description": "¿Cuántas %{units} te gustaría monitorear?",
    "excessive_submission": "¡Vaya! Estás a punto de monitorear más de 2.000 %{customPoints} para %{activity_name}. Podrías querer asegurarte de que es correcto antes de enviarlo.",
    "on": "en",
    "in": "pulg",
    "from": "de",
    "at": "en",
    "no_activities": "No hay actividades que coincidan con tu búsqueda.",
    "activity_tracking_desc": "Necesitas agregar un número para continuar. Toca la X en la esquina izquierda para cancelar.",
    "activity_tracking_desc2": "Toca en cualquier parte de la actividad para editar. Toca + para hacer un monitoreo rápido del objetivo",
    "vital_stats_title": "Sobre ti",
    "invalid_numeric_response": "Inválido",
    "invalid_numeric_response_range": "Este número debe estar entre el %{minimum} y el %{maximum}",
    "search_placeholder": "Buscar en la biblioteca...",
    "search_activities": "Actividades de búsqueda",
    "searching": "Buscando...",
    "searchEmpty": "No se han encontrado coincidencias",
    "vital_stats_description": "Cuéntanos un poco sobre ti",
    "health_survey_questions": "Preguntas de la encuesta sobre el bienestar",
    "health_survey_title": "Encuesta completa sobre el bienestar",
    "health_survey_results": "Resultados de la encuesta sobre el bienestar",
    "health_survey_card_desc": "Toma la encuesta para tener una idea de tu bienestar y fijar objetivos personalizados.",
    "apps_devices_title": "Enlazar aplicaciones y dispositivos",
    "apps_devices_card_desc": "Sincroniza tus aplicaciones y dispositivos para hacer que ganar %{customPoints} sea pan comido.",
    "interests_title": "Intereses",
    "interests_card_desc": "Cuéntanos de tus intereses. Esto nos ayudará a recomendarte objetivos y comunidades que te pueden interesar.",
    "interests_screen_desc": "¿En qué estás interesado?",
    "health_obj_title": "Objetivos de bienestar",
    "health_obj_card_desc": "Creemos que es hora de fijar algunos objetivos. Una vez que conozcamos tus objetivos podremos hacerte mejores recomendaciones. No te preocupes, si cambias de opinión puedes hacer cambios fácilmente más adelante en tu perfil.",
    "health_obj_screen_desc": "¿En qué áreas te gustaría trabajar?",
    "my_heatlh_obj": "Mis objetivos de bienestar",
    "health_topic_title": "Temas de bienestar",
    "health_topic_card_desc": "Personaliza tu experiencia especificando tus temas de bienestar.",
    "health_topic_screen_desc": "¿Sobre qué te interesa aprender?",
    "multi_select_check_error": "Selecciona al menos 1 opción para proceder",
    "my_health_topics": "Mis temas de bienestar",
    "build_your_profile": "Construye tu perfil",
    "personalize_title": "Personalizar",
    "personalize_desc": "Personaliza tu experiencia respondiendo unas cuantas preguntas rápidas.",
    "set_goals_title": "Ver objetivos recomendados",
    "set_goals_desc": "Fija objetivos personalizados para iniciar tu camino hacia una mejor salud.",
    "set_this_goal": "Fija este objetivo",
    "goal_set": "Objetivo fijado",
    "required": "Requerido",
    "apps_devices_description": "Conéctate a una plataforma de fitness para ganar más %{customPoints} automáticamente.",
    "connected": "Conectado",
    "num_connected": "(%{numDevices} conectados)",
    "available": "Disponible en",
    "inProgress": "En curso...",
    "time_a_m": "a.m.",
    "time_p_m": "p.m.",
    "last_synced": "Última sincronización",
    "last_synced_lc": "última sincronización",
    "no_connected_devices": "No hay dispositivos conectados",
    "apps_devices_confirm_disconnect": "¿Estás seguro de que quieres desconectar…",
    "button_delete": "Eliminar",
    "button_disconnect": "Desconectar",
    "button_cancel": "Cancelar",
    "button_dismiss": "Descartar",
    "ok": "Aceptar",
    "waist_helper_text": "La medida de tu cintura debe tomarse debajo de las costillas, usualmente a la altura del ombligo y mientras está de pie. Si no estás seguro, usa tu talla de pantalones.",
    "apps_devices_manage": "Manejar mis aplicaciones y dispositivos",
    "my_apps_devices": "Mis aplicaciones y dispositivos",
    "completeRegistration": "Registro completo",
    "havingTrouble": "¿Tienes problemas?",
    "contactUs": "Contacta a support@sproutatwork.com para obtener ayuda",
    "done": "Hecho",
    "brand": "Sprout",
    "cannotTrackTitle": "No puede monitorearse la actividad",
    "cannotTrackPrior": "Alto allí. Las actividades solo pueden monitorearse después de la fecha de inicio.",
    "cannotTrackFuture": "No tan rápido. Las actividades solo pueden monitorearse hasta el día actual.",
    "cannotTrack": "Las actividades no pueden monitorearse antes de la fecha de inicio o un día por delante.",
    "disclaimer": "Descargo de responsabilidad",
    "acceptTerms": "Acepto los términos y condiciones",
    "verificationEmailTitle": "Verifica tu correo electrónico",
    "email_not_yet_verified": "Parece que aún no has verificado tu dirección de correo electrónico.",
    "email_successfully_verified_title": "Bienvenido",
    "email_successfully_verified": "Has verificado tu correo electrónico exitosamente",
    "pleaseVerifyEmailMessage1": "Necesitarás verificar tu dirección de correo electrónico para continuar.",
    "pleaseVerifyEmailMessage2": "Sigue las instrucciones enviadas a:",
    "supportEmail": "support@sproutatwork.com",
    "resendEmail": "Reenviar el correo electrónico",
    "restart": "Volver al inicio de sesión",
    "firstName": "Nombre",
    "firstNamePlaceholder": "Tu nombre",
    "lastName": "Apellido",
    "lastNamePlaceholder": "Tu apellido",
    "email": "Correo electrónico",
    "emailPlaceholder": "Tu dirección de correo electrónico",
    "employeId": "Identificación de empleado",
    "employeIdPlaceholder": "Identificación de empleado de la compañía",
    "passwordPlaceholder": "Nueva contraseña",
    "datePickerTitle": "Selecciona tu fecha de nacimiento",
    "datePickerConfirm": "Confirmar",
    "datePickerCancel": "Cancelar",
    "termsOfUsePrivacyPreLinks": "Estoy de acuerdo con la",
    "sendMePromoCommunications": "Envíenme comunicaciones promocionales",
    "sendMePromoCommunicationsFromPartners": "Envíenme comunicaciones promocionales de los socios",
    "termsOfService": "Condiciones de Servicio",
    "legal": "Legal",
    "privacyPolicy": "Política de privacidad",
    "and": "y",
    "programDomainLabel": "Nombre del programa",
    "programDomainPlaceholder": "Nombre del programa",
    "findProgramName": "Encuentra el nombre de mi programa",
    "findProgramNameButton": "Busca el nombre del programa",
    "findProgramNameTitle": "Encuentra el nombre de mi programa",
    "findProgramNameDescription": "Dirección de correo electrónico de la empresa",
    "findProgramNamePlaceholder": "Dirección de correo electrónico",
    "findProgramSuccessMessage": "Los resultados de la búsqueda del nombre del programa se enviaron por correo electrónico.",
    "findProgramSuccessTitle": "Nombre del programa",
    "findProgramErrorTitle": "Nombre del programa",
    "findProgramErrorMessage": "¡Uy! Ha habido un problema... Nos encontramos con un error al intentar recuperar el nombre de tu programa. Inténtalo nuevamente.",
    "countryLabel": "Selecciona el país",
    "countryName": "País",
    "regionLabel": "Selecciona la región",
    "regionName": "Región",
    "cityLabel": "Selecciona la ciudad",
    "cityName": "Ciudad",
    "locationWorkLabel": "Selecciona el lugar",
    "locationWorkName": "Ubicación",
    "locationLabel": "Selecciona el lugar",
    "locationName": "Ubicación",
    "departmentLabel": "Selecciona el departamento ",
    "departmentName": "Departamento ",
    "no_department": "No hay departamento",
    "enterPIN": "Introduce el PIN de tu empresa",
    "verifyEmailTitle": "Verificación del correo electrónico",
    "verifyEmailMsg": "Parece que aún no has verificado tu dirección de correo electrónico.",
    "resendEmailTitle": "Verificación del correo electrónico",
    "resendEmailMsg": "Reenviado a %{userEmail}",
    "select_date": "Selecciona una fecha",
    "changePasswordTitle": "Cambia la contraseña",
    "currentPassword": "Contraseña actual",
    "newPassword": "Nueva contraseña",
    "confirmNewPassword": "Confirma la nueva contraseña",
    "passwordChangeError": {
        "currentPasswordMissing": "Introduce tu contraseña actual",
        "newPasswordMissing": "Introduce tu nueva contraseña",
        "confirmPasswordMissing": "Confirma tu nueva contraseña",
        "passwordsMatch": "Las contraseñas no coinciden",
        "passwordIncorrect": "Contraseña incorrecta. Inténtalo nuevamente."
    },
    "settings": "Configuración",
    "signOut": "Cerrar sesión",
    "updateApp": "Actualizar app",
    "updateAppRight": "V. actual: %{version}",
    "appleStoreUrlSprout": "https:\/\/itunes.apple.com\/us\/app\/sprout-at-work\/id904741273",
    "playStoreUrlSprout": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.sproutmobileapp",
    "appleStoreUrlLiveBetter": "https:\/\/itunes.apple.com\/us\/app\/live-better\/id1289314646",
    "playStoreUrlLiveBetter": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.livebetter",
    "appleStoreUrlTelus": "https:\/\/apps.apple.com\/app\/telus-health-wellbeing\/id1627569346",
    "playStoreUrlTelus": "https:\/\/play.google.com\/store\/apps\/details?id=com.telus.health.wellbeing",
    "appleStoreUrlUPnGO": "https:\/\/itunes.apple.com\/us\/app\/upngo-with-participaction\/id1079958142",
    "playStoreUrlUPnGO": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.upngo",
    "getHelp": "Obtén ayuda",
    "feedback": "Comentarios",
    "feedback_success_title": "Comentarios enviados",
    "feedback_success_msg": "Gracias por enviarnos tus comentarios, ¡lo apreciamos mucho!",
    "feedback_failure_title": "Error",
    "feedback_failure_msg": "Qué lástima... Ha habido un error al enviar tus comentarios. Inténtalo nuevamente.",
    "submit": "Enviar",
    "feedback_char_limit": "Has excedido el límite de caracteres.",
    "feedback_char_limit_toast_title": "Mensaje demasiado largo",
    "feedback_char_limit_toast_msg": "Tu mensaje excede el límite máximo de 2000 caracteres.",
    "feedback_char_length_msg_1": "Has escrito",
    "feedback_char_length_msg_2": "\/2000 caracteres.",
    "feedback_empty_toast_title": "Mensaje vacío",
    "feedback_empty_toast_msg": "Parece que no has escrito nada todavía. Escribe un mensaje antes de enviarlo.",
    "feedback_email_message": "Mensaje:",
    "feedback_email_user_id": ", Identificación del usuario:",
    "feedback_email_device": ", Dispositivo:",
    "feedback_email_os_version": ", Versión del sistema operativo:",
    "feedback_email_app_version": ", Versión de la aplicación:",
    "savingUserToast": {
        "success": {
            "title": "Guardar los cambios",
            "message": "Cambios de perfil guardados"
        },
        "danger": {
            "title": "Error encontrado",
            "message": "¡Uy! Encontramos un error al intentar guardar los cambios. Inténtalo nuevamente."
        }
    },
    "edit_profile_user_error_msg": "Revisa los errores antes de intentar guardar tus cambios",
    "edit_profile_location_error": "Necesitas especificar tu ubicación",
    "edit_profile_department_error": "Necesitas especificar tu departamento",
    "edit_profile_unspecified_value": "Necesitas especificar un valor",
    "edit_profile_value_too_low": "El valor debe ser más que",
    "edit_profile_value_too_high": "El valor debe ser menor a",
    "choose_gender": "Selecciona el género",
    "activity_tracked_successfuly": "Tu actividad se está monitoreando",
    "multi_activity_tracked_successfully": "Tus actividades se están monitoreando",
    "no_activities_tracked": "No se han monitoreado las actividades",
    "track_activity_to_submit": "Elige una fecha en el calendario para monitorear una actividad",
    "last_day": "Último",
    "days_remaining": "días restantes",
    "day_remaining": "día restante",
    "days_remaining_this_week": "días restantes de esta semana",
    "day_remaining_this_week": "día restante de esta semana",
    "days_remaining_this_month": "días restantes de este mes",
    "day_remaining_this_month": "día restante de este mes",
    "earned_today": "Ganado hoy",
    "earned_this_week": "Ganado esta semana",
    "earned_this_month": "Ganado este mes",
    "earned_in_total": "Ganado en total",
    "goal_completed": "Objetivo cumplido,",
    "see_results": "ver resultados",
    "pts": "%{customPoints}",
    "of": "de",
    "daily_goal": "Objetivo diario",
    "weekly_goal": "Objetivo semanal",
    "monthly_goal": "Objetivo mensual",
    "total_goal": "Objetivo total",
    "weeks": "semanas",
    "today": "Hoy",
    "this_week": "Esta semana",
    "this_month": "Este mes",
    "overall": "General",
    "level": "Nivel",
    "days_remaining_in_period": "%{remainingDays} días restantes",
    "days_left_in_period": "%{remainingDays} días restantes para el monitoreo",
    "pointsToLevel": "Progreso hacia %{levelName}",
    "levelCompleted": "%{levelName} completado",
    "keepTrackingUntil": "Sigue monitoreando hasta que",
    "activityLevelTitle": "Mi nivel de actividad",
    "activityLevelDescription": "¿Cuánto tiempo pasas siendo por lo menos moderadamente activo, es decir, cuando estás trabajando lo suficientemente duro para aumentar tu ritmo cardíaco y sudar, en una semana normal?",
    "activityLevelUnder60": "Menos de 60 minutos",
    "activityLevelUnder150": "60 a 150 minutos",
    "activityLevelOver150": "Más de 150 minutos",
    "gender_male": "Hombre",
    "gender_female": "Mujer",
    "gender_rather_not_say": "Prefiero no decir",
    "date_of_birth": "Fecha de nacimiento",
    "height": "Altura",
    "Height": "Altura",
    "weight": "Peso",
    "waistCircumference": "Circunferencia de la cintura",
    "bloodPressureHg": "Presión arterial sistólica",
    "bloodPressureMm": "Presión arterial diastólica",
    "bloodCholesterol": "Colesterol total en la sangre",
    "ldl": "Lipoproteína de baja densidad (LDL)",
    "hdl": "Lipoproteína de alta densidad (HDL)",
    "restingHeartRate": "Ritmo cardíaco en reposo",
    "percentageBodyFat": "Porcentaje de grasa corporal",
    "hipCircumference": "Circunferencia de la cadera",
    "bloodGlucose": "Glucosa en la sangre",
    "triglycerides": "Triglicéridos",
    "error_401_signed_out_message": "Tu sesión ha expirado. Inicia sesión nuevamente.",
    "first_name": "Nombre",
    "last_name": "Apellido",
    "preferred_name": "Nombre preferido",
    "notifications": "Notificaciones",
    "notificationsMarkAllReadButton": "Marcar todas las notificaciones como leídas",
    "notificationsSettingsButton": "Configuración",
    "notificationsSettingsTitle": "Notificaciones y correos electrónicos",
    "notificationEmptyMessage": "Estás al día con tus notificaciones",
    "priorityModalTitle": "Mis notificaciones prioritarias",
    "remindMeLater": "Recuérdamelo más tarde",
    "priorityAdminTitle": "Notificación de tu administrador",
    "markAsRead": "Marcar como leído",
    "expand": "Toca para expandir",
    "collapse": "Toca para minimizar",
    "takePhoto": "Tomar una foto nueva",
    "choosePhoto": "Elegir una foto",
    "deletePhoto": "Eliminar foto",
    "profileImageChangeErrorTitle": "Error encontrado",
    "profileImageChangeErrorMessage": "¡Uy! Algo salió mal con la edición de tu foto. Inténtalo nuevamente.",
    "editProfile": "Editar el perfil",
    "postButton": "Publicación",
    "shareYourDayName": "",
    "greeting": "¡Hola, %{firstNameDisplay}!",
    "shareAnUpdate": "¿Qué estás haciendo?",
    "shareYourDaySubtitle": "¿Qué estás haciendo?",
    "shareAPost": "Compartir una publicación",
    "postVisibleTo": "Visible para",
    "link": "Enlace",
    "photo": "Foto",
    "insertLink": "Agrega un enlace a tu publicación",
    "save": "Guardar",
    "sampleLink": "http:\/\/sample.com",
    "shareErrorText": "Necesitas agregar contenido a tu publicación antes de enviarla.",
    "generalErrorTitle": "Publicación vacía.",
    "generalSuccessTitle": "Exitoso",
    "simplePlaceholder": "¿Qué estás haciendo?",
    "likesCountLabel": "Gustos",
    "likesReceivedLabel": "Me gusta recibidos",
    "commentsCountLabel": "Comentarios",
    "commentsCountLabelSingular": "Comentario",
    "likeButton": "Me gusta",
    "commentButton": "Comentario",
    "seePreviousComments": "Ver comentarios anteriores",
    "addCommentPlaceholder": "Agrega un comentario",
    "postCommentButton": "Publicación",
    "seeMoreLongComment": "Ver más",
    "activityPoints": "%{customPoints}",
    "activityLog": "Registro de actividad",
    "discardPost": "Descartar",
    "discardPostMessage": "¿Estás seguro de que quieres descartar tu publicación?",
    "stream_filter_title": "Muro",
    "stream_filter_screen_desc": "Selecciona las publicaciones que te gustaría ver en el muro",
    "stream_filter_selection": "Mostrando:",
    "moderate": "Marcar como inapropiado",
    "moderateDescription": "Marcar este elemento como inapropiado lo eliminará y se notificará a un administrador.",
    "editPost": "Editar publicación",
    "deletePost": "Eliminar publicación",
    "deleteComment": "Eliminar comentario",
    "editComment": "Editar comentario",
    "visibleOnlyToMe": "Visible solo para mí",
    "joinEvent": "Confirma tu asistencia al evento",
    "joinEventDetail": "Unirse al evento",
    "joinedEvent": "Voy a ir",
    "joiningEventToast": {
        "success": {
            "title": "%{eventName}",
            "messageName": "Te has unido al evento",
            "message": "Te has unido a este evento exitosamente"
        }
    },
    "joinChallenge": "Unirse al desafío",
    "viewChallenge": "Ver desafío",
    "joinedChallenge": "Te uniste al desafío",
    "joinCommunity": "Unirse a la comunidad",
    "joinedCommunity": "Te uniste a la comunidad",
    "joinProgress": "Uniéndose",
    "joinSuccess": "Te uniste",
    "invitePeopleToCommunity": "Invitar a las personas a la comunidad",
    "numberOfMembers": "%{num} miembros",
    "joinToView": "Únete a esta comunidad para ver y publicar para otros miembros",
    "numberOfAttendees": "%{num} asistente(s)",
    "numberOfParticipants": "%{num} participantes",
    "numberOfMembersWithUser": "Tu y %{num} otro(s) miembro(s)",
    "numberOfAttendeesWithUser": "Tu y %{num} otro(s) asistente(s)",
    "numberOfParticipantsWithUser": "Tu y %{num} otro(s) participante(s)",
    "communityMembers": "%{numberOfMembers} miembro(s)",
    "communityEvents": "%{numberOfEvents} próximo evento",
    "myEvents": "Mis eventos",
    "seeAll": "Ver todos",
    "noUpcomingEvents": "No hay eventos próximos. ¡Unámonos a uno!",
    "myCommunities": "Mis comunidades",
    "invitedCommunities": "Invitado",
    "invitationSendingMessage": "Enviando invitaciones...",
    "invitationReceivedMessage": "te invito a unirte a esto",
    "invitationMessage": "¡Nos encantaría tenerte en nuestra comunidad!",
    "recommendedCommunities": "Recomendado para ti",
    "leaveCommunity": "Dejar esta comunidad",
    "leaveTeam": "¿Estás seguro de que quieres dejar el equipo",
    "leaveTeamLastMember": "en este desafío? Como el último miembro del equipo, dejar el desafío eliminará al equipo.",
    "leaveTeamChallenge": "en este desafío?",
    "Oops": "¡Uy! Algo salió mal",
    "editCommunity": "Editar comunidad",
    "deleteCommunity": "Eliminar esta comunidad",
    "leaveCommunityDescription": "¿Estás seguro de que quieres dejar esta comunidad?",
    "inviteToCommunity": "Invitar a la comunidad",
    "inviteByMembers": "Invitar por nombre",
    "inviteByEmail": "Invitar por correo electrónico",
    "select_person": "Seleccione al menos una persona para invitar",
    "no_users_found": "Mmm... parece que no podemos encontrar a nadie con ese nombre.",
    "promptJoinCommunities": "Parece que no te has unido a ninguna comunidad. Únete a las comunidades para comprometerte con otros y compartir tu viaje.",
    "exploreCommunities": "Explorar las comunidades",
    "sendInviteByMembers": "Invitar %{num} personas",
    "sendInviteByEmail": "Enviar invitación por correo electrónico",
    "createNewCommunity": "Crear una nueva comunidad",
    "createCommunity": "Crear una comunidad",
    "uploadCover": "Agregar una foto",
    "cover": "Portada",
    "nameOfCommunity": "Nombre de la comunidad",
    "whatCommunityAbout": "¿De qué se trata esta comunidad?",
    "companyMembersOnly": "Sólo para miembros de la compañía",
    "viewAllButton": "Ver todo",
    "communities": "Comunidades",
    "contentLibrary": "Biblioteca",
    "events": "Eventos",
    "past_events": "Eventos pasados",
    "invitationCommunity": "comunidad",
    "searchPeople": "Buscar personas",
    "enterEmail": "Colocar el correo electrónico",
    "personalMessageToNewInvitees": "Mensaje personal a los nuevos invitados",
    "dangerToastTitle": "Error",
    "dangerToastMessage": "Mmm... Algo salió mal. Inténtalo nuevamente.",
    "successToastTitle": "Exitoso",
    "successToastMessage": "Acción completada",
    "joiningToast": {
        "success": {
            "message": "Te uniste"
        }
    },
    "deletingCommentToast": {
        "success": {
            "message": "Comentario eliminado"
        }
    },
    "moderatingCommentToast": {
        "success": {
            "message": "Comentario marcado como inapropiado"
        }
    },
    "editingCommentToast": {
        "success": {
            "message": "Comentario actualizado"
        }
    },
    "gettingLikesToast": {
        "success": {
            "message": "Comentario actualizado"
        }
    },
    "updatingAvatarToast": {
        "success": {
            "message": "Foto de perfil actualizada"
        }
    },
    "deletingAvatarAvatarToast": {
        "success": {
            "message": "Foto de perfil eliminada"
        }
    },
    "creatingStreamToast": {
        "success": {
            "title": "Publica en el muro",
            "message": "Tu publicación ha sido creada"
        }
    },
    "editingStreamToast": {
        "success": {
            "title": "Editar publicación",
            "message": "Tu publicación ha sido editada"
        }
    },
    "deletingPostToast": {
        "success": {
            "title": "Eliminar publicación",
            "message": "Tu publicación ha sido eliminada"
        }
    },
    "moderatingPostToast": {
        "success": {
            "title": "Marcar como inapropiado",
            "message": "Publicación marcada como inapropiada"
        }
    },
    "markingAllNotificationsToast": {
        "success": {
            "title": "Marcar como leída",
            "message": "Todas las notificaciones marcadas como leídas"
        },
        "info": {
            "title": "Marcar como leída",
            "message": "Todas las notificaciones ya se marcaron como leídas."
        },
        "danger": {
            "title": "Marcar como leídas"
        }
    },
    "markingNotificationToast": {
        "danger": {
            "title": "No puede marcarse la notificación como leída"
        }
    },
    "changePasswordToast": {
        "success": {
            "title": "Contraseña actualizada",
            "message": "Ingresa con tu nueva contraseña"
        },
        "danger": {
            "title": "Actualizar la contraseña",
            "message": "¡Uy! Algo salió mal cuando intentamos actualizar tu contraseña. Inténtalo nuevamente."
        }
    },
    "joining": {
        "success": {
            "message": "Te uniste a %{name}"
        }
    },
    "invitingUsersToast": {
        "success": {
            "title": "Invitaciones",
            "message": "Se enviaron la(s) invitación(es)"
        }
    },
    "creatingCommunityToast": {
        "success": {
            "title": "Crear una comunidad",
            "message": "Tu nueva comunidad ha sido creada"
        }
    },
    "restartingCustomGoalToast": {
        "success": {
            "message": "Tu objetivo ha sido reiniciado"
        },
        "danger": {
            "message": "No puede reiniciarse el objetivo"
        }
    },
    "quit": "Salir",
    "wellbeing_survey_completed": "Encuesta sobre el bienestar completada",
    "wellbeing_survey_completed_message": "Gracias por completar la encuesta. Esperamos que esto te haya ayudado a comprender mejor tu bienestar.",
    "update_wellbeing_score": "Actualizar mis respuestas a la encuesta",
    "get_wellbeing_score": "Obtén tu puntuación de bienestar",
    "stats": "Estadísticas",
    "my_wellbeing_score": "Mi puntuación de bienestar",
    "see_details": "Ver detalles",
    "how_score_calculated": "¿Cómo se calcula mi puntuación?",
    "contentTitle": "Biblioteca",
    "promoted": "Destacado",
    "recommended": "Recomendado",
    "recommendedForMe": "Recomendado para mí",
    "recent": "Agregado recientemente",
    "view": "Ver",
    "added": "Agregar una foto",
    "more": "más",
    "openLibrary": "Llévame a la biblioteca",
    "readToEarn": "Leer para ganar",
    "readArticle": "Abrir enlace",
    "see_more": "Ver más (%{num})",
    "see_more_activities": "%{num} más",
    "my_achievements": "Mis logros",
    "achievements": "Logros",
    "achievement_earned_date": "Ganado: %{date}",
    "achievement_start_date": "Empezó: %{date}",
    "achievement_end_date": "Finaliza: %{date}",
    "achievement_earned": "Ganado",
    "achievement_start": "Inicia",
    "achievement_end": "Finaliza",
    "achievement_earned_times": "%{num} veces",
    "achievement_earned_time": "%{num} vez",
    "in_progress": "En curso",
    "date_earned": "Fecha en que se ganó",
    "earned": "Ganado",
    "past_dates_earned_heading": "Fechas pasadas en que se ganó",
    "all": "Todo",
    "eat": "Come",
    "move": "Muévete",
    "feel": "Siente",
    "profile_completion": "Completación del perfil: %{percentage}%",
    "complete_my_profile": "Completa tu perfil",
    "do_following_tasks": "Haz la(s) siguiente(s) %{num} tarea(s) para completar tu perfil.",
    "improve_my_score": "Mejora tu puntuación",
    "see_which_goals": "Comprueba los objetivos que te has fijado para comer, moverte y sentirte mejor.",
    "havent_set_goal": "Aún no te has fijado un objetivo.",
    "set_a_goal": "Fija un objetivo",
    "set_another_goal": "Fija otro objetivo",
    "set_another_goal_here": "Fija otro objetivo aquí.",
    "my_recently_tracked_activities": "Mis actividades recientes",
    "a_few_seconds_ago": "hace unos segundos",
    "a_day_ago": "hace un día",
    "yesterday": "Ayer",
    "earn": "Ganado",
    "delete_activity_confirmation": "¿Estás seguro de que quiere eliminar esta actividad?",
    "delete_activity_title": "¿Eliminar %{measurement} de %{activity_name}?",
    "reached_daily_goal": "Hoy has conseguido tu objetivo. ¡Bien hecho!",
    "multiple_activity_non_daily_instruction": "Toca una fila de actividad para empezar a monitorear y ganar %{customPoints}!",
    "multiple_activity_daily_instruction": "Toca en el signo más para monitorear la cantidad de una actividad necesaria para alcanzar tu objetivo. Toca en cualquier otro lugar de la fila de actividad para monitorear cualquier cantidad de esa actividad.",
    "only_automatic_activities": "Las actividades que contribuyen a este objetivo sólo pueden monitorearse automáticamente",
    "only_automatic_activity": "La actividad que contribuye a este objetivo sólo puede monitorearse automáticamente",
    "earn_pts_and_reach_goal": "Gana %{pts} puntos y alcanza tu objetivo monitoreando %{qty}",
    "earn_pts_for_every": "Gana %{pts} puntos por cada",
    "you_track": "monitorea!",
    "you_have_tracked": "Has monitoreado %{qty}",
    "so_far": "hasta ahora!",
    "start_goal": "Fija el objetivo",
    "about_this_goal": "Sobre este objetivo",
    "start_date": "Fecha de inicio",
    "end_date": "Fecha de finalización",
    "activities": "Actividades",
    "goal": "Objetivo",
    "instructions": "Instrucciones",
    "daily": "Diario",
    "weekly": "Semanal",
    "monthly": "Mensual",
    "total": "Total",
    "week": "Semana",
    "day": "Día",
    "days": "Días",
    "month": "Mes",
    "months": "Meses",
    "progress": "Progreso",
    "about": "Detalles",
    "days_remaining_to_track": "Tienes %{num} días para monitorear cualquier actividad perdida",
    "number_days": "%{num} días",
    "one_day": "1 día",
    "points_earned_this_week": "Puntos ganados esta semana",
    "points_earned_year": "Puntos ganados en lo que va de año",
    "completed": "Completado",
    "what_you_need_to_do": "Lo que necesitas hacer",
    "see_all_num": "Ver todos los %{num}",
    "my_week_progress": "Tu progreso semanal",
    "my_day_progress": "Tu progreso diario",
    "my_month_progress": "Tu progreso mensual",
    "my_total_progress": "Tu progreso total",
    "my_overall_progress": "Progreso general",
    "you_earned": "Has ganado",
    "of_this_week": "de %{num} esta semana",
    "of_this_day": "de %{num} hoy",
    "of_this_month": "de %{num} este mes",
    "of_this_total": "de %{num} en total",
    "of_this_overall": "de %{num} general",
    "remaining_this_week": "lo que resta de esta semana",
    "remaining_this_month": "lo que resta de este mes",
    "remaining_this_total": "restante",
    "remaining_this_overall": "lo que resta en general",
    "view_history": "Ver historial",
    "this_goal_is": "Este objetivo es",
    "will_run_for": "Correrás para",
    "button_unset_goal": "Objetivo no fijado",
    "button_leave_challenge": "Dejar el desafío",
    "leaveChallenge": {
        "menu": "Dejar %{challengeName}"
    },
    "deleteChallenge": {
        "menu": "Eliminar %{challengeName}"
    },
    "unsetGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "No has fijado este objetivo personal."
        }
    },
    "leaveChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Has dejado el desafío."
        }
    },
    "activities_tracked": "Actividades monitoreadas",
    "recently_tracked_activities": "Actividades monitoreadas recientemente",
    "add": "Agregar",
    "change_before_track": "Parece que no has hecho ningún cambio. Edita la cantidad de actividad de este día o sal sin hacer cambios.",
    "havent_tracked_today": "Parece que no has monitoreado ninguna actividad en este día todavía. Inicia buscando una actividad.",
    "cancel_tracking_quantity": "Cancela el monitoreo de %{quantity} de %{activity_name}",
    "points": "%{customPoints}",
    "discard_activity_edits_confirmation": "Al salir se descartarán las ediciones de tu historial de actividades. ¿Estás seguro?",
    "discard_activity_edits_confirmation_date": "Al salir, se descartarán las ediciones de tu historial de actividades para %{date}. ¿Estás seguro?",
    "yes_discard_edits": "Sí, salir y descartar las ediciones",
    "createGoal": {
        "navigatorTitle": "Crear un objetivo personal",
        "navigatorSubtitle": "Paso %{step} de 4"
    },
    "allCommunities": "Todo",
    "deleteCommunityDescription": "¿Estás seguro de que quieres eliminar esta comunidad?",
    "remaining": "restante",
    "recommended_goal": "Objetivo recomendado",
    "pinError": "El PIN %{pin} es inválido. Inténtalo nuevamente.",
    "previousPersonalGoals": "Mis objetivos personales completados",
    "previousGoalsTitle": "Mis objetivos anteriores",
    "endedOn": "finalizó en",
    "achievedOfGoal": "Lograste %{num}% del objetivo",
    "previousGoalsEmptyMessage": "No tienes objetivos previos",
    "emptyListDefaultMessage": "No tienes artículos aquí",
    "myCommunitiesEmpty": "Parece que no te has unido a ninguna comunidad. Únete a las comunidades para comprometerte con otros y compartir tu viaje.",
    "discoverMoreCommunities": "Descubre más comunidades",
    "howLong": "Duración",
    "frequency": "Frecuencia",
    "discard": "Descartar",
    "description": "Descripción",
    "optional": "opcional",
    "instruction": "Instrucción",
    "name": "Nombre",
    "create": "Crear",
    "categories": "Categorías",
    "uploadPhoto": "Agregar una foto",
    "delete_goal": "Eliminar este %{name}",
    "delete_goal_confirmation": "¿Estás seguro de que quieres eliminar este objetivo?",
    "leave_goal_confirmation": "¿Estás seguro de que quieres dejar este desafío?",
    "creatingCustomGoalToast": {
        "success": {
            "message": "Tu objetivo ha sido creado."
        }
    },
    "defaultSelectMessage": "Selecciona una opción",
    "search": "Buscar",
    "inTotal": "en total",
    "State": "Estado",
    "Business unit": "Unidad de negocios",
    "Work location": "Lugar de trabajo",
    "whenStart": "¿Cuándo quieres empezar?",
    "every": "cada",
    "acceptChallenge": "Aceptar el desafío",
    "activity_history_challenge": "Historial de actividad para el desafío",
    "havent_tracked_challenge": "No has monitoreado ninguna actividad para este desafío.",
    "earned_lowercase": "ganado",
    "noone_tracked_yet": "Nadie ha monitoreado nada todavía. ¡Empieza a monitorear para liderar esta competencia!",
    "you": "Tu",
    "your_team": "Mi equipo",
    "congrats_first_place": "¡Felicitaciones, estás en primer lugar! Sigue así.",
    "leader": "Líder",
    "average": "Promedio",
    "show_leader": "Líder del espectáculo",
    "show_me": "Muéstrame",
    "show_my_team": "Muéstrale a mi equipo",
    "leaderboard": "Tabla de clasificación",
    "my_team": "Mi equipo",
    "remaining_to_track": "que resta por monitorear",
    "avg": "prom.",
    "invite": "Invitar",
    "team_members": "Miembros del equipo",
    "daysLeft": "Días restantes",
    "regionNameLiveBetter": "Estado",
    "locationNameLiveBetter": "Lugar de trabajo",
    "departmentNameLiveBetter": "Unidad de negocios",
    "regionLabelLiveBetter": "Selecciona el estado",
    "locationLabelLiveBetter": "Selecciona el lugar de trabajo",
    "departmentLabelLiveBetter": "Selecciona la unidad de negocio",
    "companyLocation": "Lugar de trabajo",
    "no_location": "No hay lugar",
    "connect": "Conectar",
    "syncing": "Sincronizando",
    "sync": "Sincronizar",
    "havent_tracked_in_a_while": "No hay actividades monitoreadas recientemente",
    "contact": "Contactar",
    "manage": "Gestionar",
    "creator": "Creador",
    "allow_notifications": "Gestionar las notificaciones",
    "enable_notifications": "Activar las notificaciones",
    "appload": "Espera un momento mientras {app_name} se actualiza...",
    "sendResetEmail": "Enviar correo electrónico de restablecimiento",
    "min": "Min",
    "max": "Max",
    "error_joining_team": "No puedes unirte al equipo",
    "cannot_add_to_team": "¡Uy! Algo salió mal cuando intentamos agregarte a este equipo. Puede ser que el equipo haya alcanzado su número máximo de miembros o que ya no exista. En caso de que ocurriera otro error, inténtalo nuevamente.",
    "members_needed": "Se necesitan %{num} miembros",
    "member_needed": "Se necesita %{num} miembro",
    "spots_left": "%{num} puestos restantes",
    "join": "Únete",
    "no_teams_create": "Actualmente no hay ningún equipo para que te unas. ¿Por qué no creas uno?",
    "number_teams": "%{num} equipos",
    "youLowercase": "tu",
    "joined_challenge_on_team": "Te has unido a un desafío en el equipo %{team_name}.",
    "join_team": "Únete a un equipo",
    "former_members": "Antiguos miembros",
    "letsGo": "Vámonos",
    "invite_to_team": "Invita a formar un equipo",
    "connectingDeviceToast": {
        "success": {
            "title": "Conectar una aplicación o dispositivo",
            "message": "¡Exitosos! Tu aplicación o dispositivo está conectado."
        },
        "danger": {
            "title": "Conectar una aplicación o dispositivo",
            "message": "¡Uy! Tuvimos un problema para conectar este servicio. Inténtalo nuevamente."
        }
    },
    "disconnectingDeviceToast": {
        "success": {
            "title": "Desconectar una aplicación o dispositivo",
            "message": "Se ha desconectado exitosamente %{name}."
        },
        "danger": {
            "title": "Desconectar una aplicación o un dispositivo",
            "message": "¡Uy! Tuvimos un problema al desconectar %{name}. Inténtalo nuevamente."
        }
    },
    "leave_entity_question": "¿Dejar %{name}?",
    "delete_entity_question": "¿Eliminar %{name}?",
    "leave_team_challenge_confirmation": "¿Estás seguro de que quieres dejar %{name} en este desafío?",
    "leave_last_team_member": "Como el último miembro del equipo, dejar este desafío eliminará al equipo.",
    "oops_msg": "¡Uy! Hubo un error al intentar completar esta acción. Inténtalo nuevamente.",
    "has_been_created": "Te has unido al desafío en el equipo %{name}.",
    "specify_team_name": "Especifica el nombre del equipo",
    "invite_members": "Invita miembros",
    "upload_photo_no_question": "Agrega una foto",
    "my_progress": "Mi progreso",
    "rewardsPointsAdditionalInfo": "Gana %{reward_currency} por cada nivel que alcances cada %{period}. Tus %{customPoints} y tus niveles inician nuevamente cada %{period}, por lo que tienes la oportunidad de seguir ganando %{reward_currency} incluso si alcanzaste el nivel más alto el último período.",
    "rewardsPointsInfo": "Tus %{customPoints} y el progreso se reinician cada %{period}.",
    "departments": "Departamentos",
    "regions": "Regiones",
    "noItemsSelected": "No hay elementos seleccionados",
    "pleaseSelectOne": "Selecciona al menos un elemento de la lista",
    "tracked": "Monitoreado",
    "starts": "Inicia",
    "duration": "Duración",
    "bonus": "Bonificación",
    "invited_by": "Invitado por",
    "create_team": "Crear un equipo",
    "discardConfirmation": "¿Estás seguro de que quieres salir?",
    "discardYes": "Sí",
    "discardStay": "Regresar",
    "create_team_toast_title": "Crear un equipo",
    "edit_team": "Editar equipo",
    "team_edits_submitted": "Tu equipo ha sido actualizado.",
    "challenge_ended_still_trackable": "Este %{type} finalizó, ¡por suerte te quedan %{num} días para monitorear!",
    "tracking_period_ended": "El período de monitoreo de este %{type} finalizó.",
    "unlimited": "Ilimitado",
    "ends_in": "Finaliza en",
    "challenge_toast": {
        "success": {
            "join": "¡Exitoso!",
            "message": "Te has unido al desafío exitosamente."
        },
        "danger": {
            "error": "Error",
            "message": "Algo salió mal. Intenta unirte al desafío nuevamente más tarde."
        }
    },
    "members_to_invite": "Miembros para invitar",
    "members_to_remove": "Miembros para eliminar",
    "myChallenges": "Competencias",
    "upcoming": "Próximamente",
    "myPersonalGoals": "Objetivos",
    "companyCompetitions": "Competencias de la compañía",
    "communityCompetitions": "Competencias comunitarias",
    "edit_your_team": "Edita tu equipo",
    "emails": "Correos electrónicos",
    "CompletedOverall": "Completado en general",
    "TotalEarned": "Total ganado",
    "notify_header": "Me gustaría ser notificado:",
    "AdditionalBonus": "Bonificación adicional",
    "goalEndedNotification": "El objetivo finalizó, ¡sigue esforzándote!",
    "compEndedNotification": "La competencia finalizó, ¡sigue esforzándote!",
    "congrats_tracking_first": "¡Felicitaciones por monitorear tu primera actividad!",
    "keep_tracking": "Sigue monitoreando tu actividad para lograr objetivos y subir de nivel.",
    "understanding_tracking": "Entendiendo el monitoreo",
    "cannot_track_this_day": "No puedes monitorear en este día.",
    "nothing_tracked_this_day": "Aún no has monitoreado este día.",
    "tracked_something_this_day": "Has monitoreado algo para este día.",
    "reached_goal_this_day": "Has alcanzado tu objetivo para este día (sólo para los objetivos diarios).",
    "got_it": "¡Lo logré!",
    "notDismissedMultiTitle": "Resumen del desafío",
    "notDismissedMultiSubtitle": "Algunos desafíos han finalizado. Observa más profundamente cada uno de ellos para conocer los detalles de cómo lo hiciste.",
    "daySummary": "%{userName}, aquí hay un resumen de tu día hasta ahora",
    "goals": "Objetivos",
    "competitions": "Competencias",
    "totalAccumulated": "Total acumulado",
    "tracking_for_date": "Monitoreando para %{date}",
    "activity_tracker_instruction": "Toca para editar o eliminar una actividad de monitoreo manualmente",
    "ended": "Finalizado",
    "notYetAvailableBeta": "Todavía no está disponible en beta",
    "suggestedGoal": "Objetivo sugerido",
    "singleFor": "para",
    "seeLessLongComment": "Ver menos",
    "synced_data": "Datos sincronizados:",
    "doThisLater": "Lo haré más tarde",
    "inviteUsers": "Invita a otros a unirse",
    "cannotTrackAfterDeadline": "Estás tratando de monitorear una actividad para una fecha posterior a la fecha límite del desafío.",
    "potentialBonusPoints": {
        "section": {
            "title": "¡%{potentialBonusPoints} %{customPoints} de bonificación están disponibles para este objetivo!",
            "titleNotCompleted": "Te perdiste los %{potentialBonusPoints} %{customPoints} de bonificación por %{activitytCompletedPercentage}%.",
            "titleCompleted": "¡Felicitaciones! Te has ganado",
            "titleCompletedBold": "%{potentialBonusPoints} %{customPoints} de bonificación",
            "subtitle": "Aprende más sobre los %{customPoints} de bonificación"
        },
        "modal": {
            "title": "%{customPoints} de bonificación",
            "desc1": "Sabemos que nadie es perfecto para completar sus objetivos el 100% de las veces.",
            "desc2": "Es por eso que otorgamos %{customPoints} de bonificación cuando tu progreso general es de 85% o más.",
            "desc3": "Todos los %{customPoints} de bonificación se otorgan después de que el objetivo finaliza y si todo tu monitoreo fue desde una aplicación o dispositivo conectado, ¡recibirás el doble de %{customPoints} de bonificación!",
            "desc4": "No recibirás %{customPoints} de bonificación por objetivos de los que salgas antes de tiempo."
        },
        "msg": {
            "title": "Este objetivo ha finalizado",
            "subtitle": "El objetivo finalizó en %{goalEndedDate}"
        },
        "msgEnded": {
            "title": "¡Se acabó el tiempo! Tu objetivo ha finalizado",
            "subtitle": "Tienes %{daysNum} %{daysOrDay} para monitorear tu actividad."
        }
    },
    "finish": "Finalizar",
    "personalGoal": {
        "all_goals": {
            "selected": "¡Los %{maxGoals} objetivos fijados!",
            "description": "¿Te gusta esto? Puedes reemplazar cualquier objetivo si cambias de opinión. No te preocupes, podrás desactivar tu objetivo más tarde.",
            "set": "¡Todos los objetivos han sido fijados!",
            "action": "¡Todo listo y preparado para empezar!",
            "error": "¡No nos dejemos llevar! Enfocarse en un máximo de 3 objetivos estructurados a la vez aumentará tus posibilidades de éxito.",
            "errorHeading": "Fijando objetivos"
        },
        "set_more": "Puedes fijar %{maxGoals} objetivos más activos.",
        "select_goal": {
            "heading": "Fija un objetivo recomendado o crea el tuyo propio"
        },
        "set_more_1": "Puedes fijar un objetivo más activo"
    },
    "restartPersonalGoal": "Reinicia el objetivo con nuevas metas",
    "delete_challenge_confirmation": "¿Estás seguro de que quieres eliminar este desafío?",
    "personal_goal_unit": "objetivo",
    "personal_goal_units": "objetivos",
    "day_summary": {
        "steps_taken": "Medidas tomadas",
        "calories_in": "Calorías dentro",
        "calories_out": "Calorías fuera",
        "avg_daily": "promedio diario",
        "most_earned_daily": "la mayoría gana un día"
    },
    "invitedBy": "Invitado por %{person}",
    "resetPasswordMissingField": "Coloca un correo electrónico",
    "resetPasswordInvalidValue": "Coloca una dirección de correo electrónico válida",
    "resetPasswordNotFound": "Tu correo electrónico no se pudo encontrar",
    "resetPasswordNotCompleted": "Tu solicitud no pudo ser completada",
    "resetGoalInstructions": {
        "start": "Haz %{quantity} %{units} de %{activity}",
        "additional": ", %{quantity} %{units} de %{activity}",
        "end": "%{frequency} y gana %{points} %{customPoints} %{frequency}"
    },
    "goalSet": {
        "one": "Un objetivo fijado. Ver",
        "two": "Dos objetivos fijados. Ver",
        "three": "Tres objetivos fijados. Ver",
        "none": "No se han fijado objetivos. Fijar objetivos"
    },
    "searchCommunitiesEmpty": "No se han encontrado comunidades",
    "searchCommunitiesPlaceholder": "Buscar en las comunidades",
    "updating": "Actualizando...",
    "pts_tracked": "%{activityName} monitoreado - %{num} %{customPoints}",
    "improving_wellbeing_score": "Sigue así, estás en camino de mejorar tu puntuación de bienestar.",
    "progressHistory": "Historial de progreso",
    "privateCommunity": "Esta es una comunidad privada",
    "do_combo_of_activities": "Haz cualquier combinación de lo siguiente.",
    "noActivitiesTracked": "No se han monitoreado las actividades",
    "trackingWithFollowingApps": "Monitoreo con las siguientes aplicaciones\/dispositivos",
    "recommendedApps": "Aplicaciones\/dispositivos recomendados para este %{challengeType}",
    "collapseWord": "Minimizar",
    "started": "Iniciando",
    "ends": "Finaliza",
    "do_activities": "Hacer actividades",
    "rewards_placeholder": "Ejemplo de recompensas de la tienda, marcador de posición. Los usuarios verán varios productos que pueden comprar y el costo en %{rewardName}.",
    "personalGoals": {
        "top": {
            "label": "Arriba"
        },
        "allGoals": "Todos los objetivos",
        "seeMoreCard": {
            "heading": "¿No ves lo que estás buscando?",
            "description": "Echa un vistazo a todos los objetivos recomendados",
            "button": "Explorar los objetivos"
        }
    },
    "rewardsNotAvailable": "Actualmente no hay recompensas disponibles en esta beta. Cuando estén disponibles, podrás ver el catálogo y completar un canje.",
    "editProfileProvideRestingHeartRate": "Coloca un valor válido de frecuencia cardíaca en reposo de al menos 40",
    "liveBetterHealthInfo": "Dirigimos una serie de programas y tenemos una variedad de contenido de salud diseñado para apoyar una gama de necesidades de salud y ayudarte a lograr una Mejor Salud. Todavía no tenemos programas para cada condición y necesidad de salud, ¡estamos trabajando en ello! Sin embargo, si respondes a las siguientes preguntas, nos comunicaremos contigo si identificamos algún programa o servicio de salud del que puedas beneficiarte al participar y\/o te enviaremos información basada en evidencias que le ayudarán a entender y manejar mejor tus necesidades de salud. Considera que no utilizamos esta información para evaluar la idoneidad de tu póliza. Si deseas saber qué es lo que tienes cubierto o tienes alguna pregunta sobre tu póliza, puedes llamar a nuestro equipo de Conexión con el Cliente al 132 331.",
    "deleteGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Has eliminado el objetivo"
        }
    },
    "deleteChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Has eliminado el desafío"
        }
    },
    "invitations": "Invitaciones",
    "learnMorePeriods": "Más información sobre los períodos",
    "tracked_by_app_name": "Monitoreado por %{app_name}",
    "device_required": {
        "text": "Este %{challengeType} requiere una aplicación o dispositivo",
        "button": "Conectar una aplicación o dispositivo"
    },
    "editingCommunityToast": {
        "success": {
            "title": "Editar comunidad",
            "message": "La comunidad ha sido editada"
        }
    },
    "competition": "Competencia",
    "close": "Cerrar",
    "only_automatic_activities_with_device": "Se hace un seguimiento automático de las actividades de esta %{goal_or_competition} mediante las apps\/dispositivos conectados.",
    "only_automatic_activity_with_device": "Se hace un seguimiento automático de las actividad de esta %{goal_or_competition} mediante las apps\/dispositivos conectados.",
    "deletingCommunityToast": {
        "success": {
            "title": "%{name}",
            "message": "Comunidad eliminada"
        }
    },
    "teamSizeMessage": "Tu equipo necesita al menos %{min} personas que ganen %{customPoints} para el desafío.",
    "captain": "Capitán",
    "inviteOthersToTeam": "Invitar a otros a mi equipo",
    "loadingMetrics": "Conectando con las fuentes para actualizar tu día...",
    "aboutTeamSize": {
        "title": "Tamaño del equipo",
        "text": "de %{min} a %{max}"
    },
    "pointsOverview": "Resumen de %{customPoints}",
    "deepLinks": {
        "requestCouldNotBeCompleted": "Tu solicitud no pudo completarse",
        "error": "Error"
    },
    "required_lc": "requerido",
    "personal": "Datos personales",
    "biometrics": "Biometría",
    "makeSelection": "Haz una selección",
    "ask_question_success_msg": "Gracias. Responderemos tan pronto como podamos.",
    "report_issue_success_msg": "Gracias. Responderemos tan pronto como podamos.",
    "ask_question_success_title": "Pregunta enviada",
    "report_issue_success_title": "Asunto técnico enviado",
    "ask_question_failure_msg": "Qué lástima... Ha habido un error al enviar tu pregunta. Inténtalo nuevamente.",
    "report_issue_failure_msg": "Qué lástima... Ha habido un error al reportar tu asunto. Inténtalo nuevamente.",
    "notTrackedActivities": "No has monitoreado ninguna actividad durante este período",
    "learn": "Aprende",
    "Balance": "Balance",
    "details": "Detalles",
    "Reward": "Recompensa",
    "levelsReset": "Los niveles se reinician en %{remainingDays} días",
    "redeem": "Canjear",
    "redeemAt": "Canjear en %{points}",
    "needPointsToRedeem": "Necesitas %{points} más %{rewardName}.",
    "learnEarnMore": "Aprende a ganar más",
    "currency": "SproutBucks",
    "joiningTeamChallengeToast": {
        "success": {
            "title": "Únete al equipo",
            "message": "¡Te has unido al equipo exitosamente!"
        },
        "danger": {
            "message": "Nos hemos encontrado con un error y no hemos podido encontrar el equipo. Puede que ya no exista."
        }
    },
    "NoMatchingDeepLinkToast": {
        "danger": {
            "title": "Acción no disponible",
            "message": "Tu solicitud no pudo ser completada."
        }
    },
    "transactionLog": "Transacciones",
    "orderHistory": "Ordenes",
    "pointsAvailableToEarn": "%{points} disponibles para ganar",
    "missedYTD": "%{missed} YTD (EHF) perdido.",
    "rewardsDetails": "Recompensas",
    "successfullyRedeemedItem": "Has canjeado este artículo exitosamente",
    "orderNumber": "Número de pedido",
    "amountSpent": "Cantidad gastada",
    "status": "Estado",
    "dateRedeemed": "Fecha de canje",
    "additionalInformation": "Información adicional",
    "shipToAddress": "Enviar a esta dirección",
    "pointMissedYearToDate": "%{rewardCurrencyName} perdida este año",
    "pointMissedYearToDateDescription": "Cuando no alcanzas un nivel antes de que el período finalice, el %{rewardCurrencyName} asociado que podrías haber ganado se considera perdido.",
    "NoLibraryContentToast": {
        "info": {
            "title": "Artículo no encontrado",
            "message": "No pude encontrar el artículo. Puede que haya sido eliminado o que ya no esté disponible."
        }
    },
    "CommunityNotFoundToast": {
        "danger": {
            "title": "No se encontró la comunidad",
            "message": "No pude encontrar la comunidad. Puede que haya sido eliminado o que ya no esté disponible."
        }
    },
    "shippingAddress": "Dirección de envío \/ facturación",
    "enterShippingAddress": "Coloca tu dirección de envío \/ facturación",
    "streetLine": "Línea de la calle %{num}",
    "stateProvince": "Estado\/Provincia",
    "postcodePostalcodeZip": "Código postal",
    "phoneNumber": "Número telefónico",
    "order": "Pedido",
    "redemptionConfirmation": "Confirmación del canje",
    "edit": "Editar",
    "processing": "Procesando",
    "checkIsYouFirst": "Sólo tenemos que comprobar si tú eres primero",
    "discardSomeGoals": "Te has fijado algunos objetivos. Estos objetivos serán descartados si procedes.",
    "settingGoalsToast": {
        "success": {
            "message": "¡Tus nuevos objetivos han sido fijadas!"
        }
    },
    "one_team": "1 equipo",
    "noAchievementsToEarnMessage": "Parece que no hay más insignias para ganar %{rewardCurrencyName} este período.",
    "shopRewards": "Recompensas de la tienda",
    "validateShippingAddressToast": {
        "danger": {
            "title": "Dirección de envío \/ facturación",
            "message": "Completa todos los campos antes de continuar."
        }
    },
    "viewDetails": "Ver detalles",
    "potential": "Potencial",
    "missed": "Falta",
    "rewardsStoreNotAvailable": "La tienda de recompensas no está disponible para ti en este momento.",
    "havent_tracked_in_a_while_date": "No hay actividades monitoreadas para %{currentDate}",
    "challengeNotFoundToast": {
        "danger": {
            "title": "Desafío no encontrado",
            "message": "No pude encontrar el desafío. Puede que haya sido eliminado o que ya no esté disponible."
        }
    },
    "shareYourDaySubtitleActivity": "¡Agrega una foto o di algo sobre esta actividad!",
    "goal_ended": "Objetivo finalizado",
    "challenge_ended": "Desafío finalizado",
    "day_remaining_to_track": "Tienes un día para monitorear cualquier actividad perdida",
    "challengeGoalCardSubtitleEndDate": "%{challengeOrGoal} finalizó en %{endDate}",
    "goalEndedModal": {
        "title": "Ponte al día con la actividad olvidada",
        "message": "Después de que un objetivo personal o un desafío haya finalizado, tienes tres días desde la fecha de finalización para monitorear cualquier actividad que puedas haber olvidado. Después de este período de gracia, no puedes monitorear ninguna actividad adicional que contribuya al objetivo o desafío."
    },
    "summary": "Resumen",
    "placedRank": "Estás ubicado en el %{rank} de %{total}",
    "rank": {
        "first": "1er",
        "second": "2do",
        "third": "3ro",
        "n": "%{rank}°"
    },
    "event_name": "Nombre del evento",
    "this_is": "Esto es un",
    "location_info": "Ubicación e información",
    "what_event": "¿De qué se trata este evento?",
    "event_is": "Este evento es",
    "start_on": "Fecha de inicio:",
    "end_on": "Fecha de finalización:",
    "location": "Ubicación",
    "chooseLeaderboard": "Elige una tabla de clasificación",
    "filterOneOfFollowing": "Filtra uno de los siguientes",
    "showChallengeInstead": "Muestra un desafío en su lugar",
    "showActivityInstead": "Muestra una actividad en su lugar",
    "showAll": "Mostrar todo",
    "activitiesShowSame": "Actividades: %{activityName}",
    "challengeShowSame": "Desafío: %{challengeName}",
    "chooseTimePeriod": "Elige un período",
    "youCanFilterOneAtTime": "Se puede seleccionar un filtro a la vez",
    "saveHealthTopicsToast": {
        "success": {
            "message": "Temas de salud guardados",
            "title": "¡Exitoso!"
        },
        "info": {
            "message": "No puede guardarse"
        },
        "danger": {
            "title": "¡Error!"
        }
    },
    "saveHealthObjectivesToast": {
        "success": {
            "message": "Objetivos de salud guardados",
            "title": "¡Exitoso!"
        },
        "info": {
            "message": "No puede guardarse"
        },
        "danger": {
            "title": "¡Error!"
        }
    },
    "saveInterestGroupsToast": {
        "success": {
            "message": "Intereses guardados",
            "title": "¡Exitoso!"
        },
        "info": {
            "message": "No puede guardarse"
        },
        "danger": {
            "title": "¡Error!"
        }
    },
    "edit_event": "Editar evento",
    "leave": "Dejar",
    "delete_event": "Eliminar evento",
    "no_events": "No hay eventos",
    "no_events_placeholder": "No estás planeando asistir a ningún evento futuro. ¿Por qué no te unes a uno?",
    "event": "evento",
    "challenge": "Desafío",
    "invited_you": "Te he invitado",
    "public": "Público",
    "private": "Privado",
    "deleteEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Evento eliminado con éxito."
        }
    },
    "leaveEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Has dejado el evento"
        }
    },
    "editEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Evento actualizado exitosamente."
        }
    },
    "createEventToast": {
        "success": {
            "message": "Evento creado exitosamente.",
            "title": "%{eventName}"
        }
    },
    "contentIsDeletedOrInappropriate": "El contenido que estás tratando de ver no está disponible actualmente. Puede que haya sido eliminado por el autor o marcado como inapropiado.",
    "start_time": "Hora de inicio",
    "end_time": "Hora de finalización",
    "event_type": "Evento %{eventType}",
    "leave_event_modal": {
        "title": "Si dejas este evento",
        "message": "Se eliminará"
    },
    "leave_event ": "¿Estás seguro de que quieres dejar este evento?",
    "create_event": "Crear evento",
    "created_by": "Creado por",
    "eventActionToast": {
        "danger": {
            "title": "Error",
            "message": "Algo salió mal."
        }
    },
    "continue": "Continúa",
    "wantExitTour": "¿Estás seguro de que quieres salir del recorrido?",
    "exitTour": "Salir del recorrido",
    "deleveEventPopup": "¿Estás seguro de que quieres eliminar este evento?",
    "attendeesTitle": "Asistentes",
    "userEvents": "Los eventos de %{name}",
    "createEventIndicator": "Creando el evento",
    "inviteToEvent": "Invitar al evento",
    "noDescription": "No hay ninguna descripción.",
    "leaderboardIsEmpty": "Esta tabla de clasificación está vacía o es posible que necesites monitorear la actividad dentro del período de tiempo seleccionado para verla",
    "notParticipantingInAnyChallenges": "No estás participando en ningún desafío",
    "buttonLeaveEvent": "Dejar el evento",
    "leaveEvent ": "¿Dejar %{nombre}?",
    "canceledCreatingChallenge": "La creación de un %{challengeType} ha sido cancelada exitosamente",
    "swipeReadNotification": "Leer",
    "productTour": {
        "initialScreen": {
            "title": "¡Bienvenido a %{programName}!",
            "body": "Hagamos un recorrido y en unos momentos conocerás lo básico."
        },
        "dashboard": {
            "title": "Panel de control",
            "body": "Mira cuántos %{pointsName} tienes y tu progreso hacia los niveles. Luego revisa la tabla de clasificación para ver cómo acumular."
        },
        "rewards": {
            "title": "Recompensas",
            "body": "Mira cuántos %{rewardPointName} tienes y canjéalos en la tienda."
        },
        "goals": {
            "title": "Objetivos y desafíos",
            "body": "Tus objetivos personales activos, desafíos con otros y tareas especiales pueden encontrarse aquí."
        },
        "explore": {
            "title": "Explora",
            "body": "Encuentra desafíos con otros, únete a las comunidades para discutir tus intereses y descubre un nuevo artículo en la biblioteca del bienestar."
        },
        "me": {
            "title": "Yo",
            "body": "Encuentra tu puntuación de bienestar, comprueba tus estadísticas y edita tu perfil y configuración aquí."
        },
        "finishScreen": {
            "title": "Todo está listo",
            "body": "Gracias por completar el recorrido.",
            "button": "Comencemos"
        },
        "skip": {
            "title": "¿Estás seguro de que quieres saltarte el recorrido?",
            "body": "Esto finalizará el recorrido y podrás empezar de inmediato."
        }
    },
    "getTemporaryRewardRedemptionTokenToast": {
        "danger": {
            "title": "Fallo de autenticación",
            "message": "No pude proceder con el canje de la recompensa. Se produjo un error al autenticarse con el proveedor de la recompensa."
        }
    },
    "rewardRedemptionFailureToast": {
        "danger": {
            "title": "El canje falló",
            "message": "%{displayMessage}"
        }
    },
    "disclamerSectionTitle": "Antes de que empieces",
    "disclamerSectionMessage": "Consulta con tu profesional de la salud antes de iniciar cualquier nuevo programa de ejercicios o de hacer cambios en tu estilo de vida para asegurarte de que son adecuados para ti.",
    "noEarchedAchievements": "Aún no has obtenido ningún logro. Monitorea una actividad para empezar.",
    "noInProgressAchievements": "No tiene ningún logro en progreso.",
    "discardCreatingEventMessage": "Comprueba que se han introducido todos los campos obligatorios",
    "discardCreatingEventTitle": "El evento no puede crearse",
    "discardEditedEventTitle": "El evento no puede editarse",
    "errorEventNameMessage": "El nombre es requerido",
    "errorEventStartDateMessage": "Se requiere una fecha de inicio",
    "errorEventEndDateMessage": "Se requiere una fecha de finalización",
    "errorEventDateMessage": "La fecha de finalización no puede ser anterior a la fecha de inicio",
    "noAccountsToLink": "No hay cuentas disponibles para enlazar con %{program_name}.",
    "accountLinkEmailChanged": "Tu dirección de correo electrónico ha sido actualizada. En el futuro, inicia sesión con tu cuenta enlazada.",
    "accountLinkSuccessful": "Tu cuenta ha sido vinculada exitosamente.",
    "edit_profile_nan_value": "El valor debe ser un número",
    "advancedLogIn": "Inicio de sesión avanzado",
    "redemptionSessionExpiredToast": {
        "danger": {
            "title": "El canje falló",
            "message": "La sesión del pedido ha expirado. Intenta hacer el pedido nuevamente."
        }
    },
    "left": "restantes",
    "eventsCarousel": {
        "emptyEvent": {
            "prompt": "Parece que no hay eventos disponibles para unirse en este momento. ¿Por qué no creas uno?"
        }
    },
    "reachedHighestLevel": "¡Has alcanzado el nivel más alto!",
    "error": "Error",
    "redeemRewardSuccessfulToast": {
        "success": {
            "title": "Canje de la recompensa",
            "message": "Tu pedido ha sido realizado"
        }
    },
    "redeemRewardComplete": "Canje completo",
    "trackActivityTitle": {
        "oneUnit": "Monitoreo: 1 %{unit} de %{activity} el %{date}",
        "nUnit": "Monitoreo: %{activity} para %{date}"
    },
    "ssoAuthenticationFailure": "Fallo de autenticación",
    "earnEvery": "Gana cada %{frequency}",
    "earnOnce": "Ganar solo una vez",
    "goalSettings": {
        "maximumSet": "Actualmente tienes el máximo de 3 objetivos fijados.",
        "learnMore": "Más información sobre la fijación de objetivos"
    },
    "allowMarketingComms": "Envíenme comunicaciones promocionales",
    "allowPartnerMarketingComms": "Envíenme comunicaciones promocionales de los socios",
    "noUpcomingAchievements": "No tienes ningún logro futuro.",
    "settingGoalToast": {
        "success": {
            "message": "¡Tu nuevo objetivo ha sido fijado!"
        }
    },
    "authentication": {
        "saml": {
            "error": "Servicio no disponible actualmente",
            "signin": "Inicio de sesión integrado",
            "signup": "Registro integrado"
        }
    },
    "monthName": {
        "january": "Enero",
        "february": "Febrero",
        "march": "Marzo",
        "april": "Abril",
        "may": "Mayo",
        "june": "Junio",
        "july": "Julio",
        "august": "Agosto",
        "september": "Septiembre",
        "october": "Octubre",
        "november": "Noviembre",
        "december": "Diciembre"
    },
    "promotedForMe": "Destacado",
    "appRating": {
        "enjoying": "¿Disfrutando de nuestra aplicación?",
        "feedback": "¿Te gustaría darnos su opinión?",
        "appStore": "¿Valóranos en la App Store?",
        "googlePlay": "¿Valóranos en Google Play?",
        "notReally": "No realmente",
        "yes": "¡Sí!",
        "sure": "Seguro",
        "noThanks": "No, gracias",
        "notNow": "Ahora no"
    },
    "getMobileApp": "Para usar %{programName} en tu Smartphone, descarga %{appStoreName} de la App Store o Google Play.",
    "newAppsDevicesDesign": {
        "getMobileApp": "Descarga la aplicación %{programName}",
        "searchInAppStore": "Busque %{programName} en la tienda de aplicaciones de su dispositivo",
        "getMobileAppNoName": "Consigue la app móvil"
    },
    "editorAlert": {
        "discardChanges": "Descartar los cambios",
        "saveAndContinue": "Guardar y continuar",
        "title": "Cambios no guardados",
        "text": "Has hecho algunos cambios que no se han guardado. ¿Qué te gustaría hacer?"
    },
    "resources": "Recursos",
    "noResources": "No hay recursos disponibles",
    "viewAllResources": "Ver todos los recursos",
    "language": "Idioma",
    "eventStarted": "El evento inició. Registro cerrado.",
    "Gender": "Género",
    "show": "Mostrar",
    "hide": "Ocultar",
    "timeoutError": "¡Uy! Algo está tardando demasiado. Inténtalo nuevamente más tarde.",
    "SOT": {
        "sample_task": "Ejemplo de tarea"
    },
    "cache": {
        "new_version": "¡Una nueva versión está disponible!",
        "refresh_browser": "Haz clic aquí para actualizar tu navegador."
    },
    "welcomeUser": "Bienvenido, %{userFirstName}!",
    "quarter": "trimestre",
    "completionReward": "Recompensa por culminación",
    "bronzeLevel": "Nivel bronce",
    "deviceAppSyncingOk": "Sincronización de dispositivo \/ aplicación, aceptar",
    "deviceAppSyncingIssue": "Problema de sincronización de dispositivo \/ aplicación",
    "deviceAppSyncingError": "Error de sincronización de dispositivo \/ aplicación",
    "lastSync": "Última sincronización",
    "period": "período",
    "yourDaySummary": "Tu día hasta ahora",
    "steps": "Pasos",
    "gender_non_binary": "No binario o no conforme",
    "take_survey": "Toma la encuesta",
    "social": "Social",
    "finalDay": "Día final",
    "leaderboard_position": "Posición en la tabla de clasificación",
    "signUp": {
        "apple": {
            "disconnectSettings": "Desconecta %{appName} de 'Contraseña y Seguridad de Apple ID' en la Configuración del teléfono para seguir registrándote"
        }
    },
    "earnPoints": "Gana %{customPoints}. Sube de nivel.",
    "getReward": "Gana %{rewardName}.",
    "buildHealthyHabits": "Construye hábitos saludables.",
    "highestLevelIndicator": "¡Has alcanzado el nivel más alto!",
    "highestLevelIndicatorNew": "¡Has completado todos los niveles!",
    "trackYourActivity": "Para obtener %{customPoints} monitorea tu ejercicio y actividad de bienestar.",
    "levelUpToGetRewarded": "A medida que subas de nivel serás recompensado con %{rewardName}.",
    "levelUpAndEarn": "Tu progreso se reajusta cada %{period} para que puedas subir de nivel y ganar una y otra vez.",
    "levelUp": "Tu progreso se restablece cada %{period} para que puedas subir de nivel una y otra vez.",
    "goToLibrary": "Ir a la biblioteca",
    "updateEventIndicator": "Evento de actualización",
    "meTour": {
        "healthSurveyDisabled": "Revisa tus estadísticas y edita tu perfil y tu configuración aquí."
    },
    "createNewGoal": "Crea un nuevo objetivo",
    "later": "Más tarde",
    "bonusChallenge": "Desafío de bonificación",
    "bonusChallengeInfo": {
        "withReward": "Ganarás %{amount} %{points} de bonificación por completar al menos 85% de este %{challengeType}.",
        "noReward": "Ganarás una bonificación por completar al menos 85% de este desafío.",
        "boldText": "%{amount} %{points} de bonificación",
        "noRewardChallengeType": "Ganarás una bonificación por completar al menos el 85% de este %{challengeType}"
    },
    "defaultApp": "Tu aplicación de salud por defecto",
    "bonusGoal": {
        "additionalInfo": "Si toda tu actividad se monitoreó utilizando una aplicación o dispositivo conectado, ¡recibirás el doble de %{points} de bonificación!",
        "additionalInfoNew": {
            "paragraph2": "Los %{points} de bonificación se otorgan después de que el objetivo haya finalizado. No recibirás %{points} de bonificación por los objetivos que dejes antes de tiempo."
        },
        "boldText": "el doble de %{points} de bonificación!",
        "markTitle": "Meta de bonificación"
    },
    "notify_me": "Notifícame",
    "bonusChallengeReward": "Recompensa de desafío de bonificación",
    "forCompletingChallenge": "Para completar %{challengeName}",
    "notifications_text": "Las notificaciones te ayudan a cumplir tus objetivos y a estar al día en las conversaciones.",
    "type_here": "Escribe aquí",
    "bonusEarned": "Bonificaciones ganadas",
    "youEarnedBonus": "¡Te ganaste esta bonificación!",
    "inviteOthersToChallenge": "Invita a otros a unirse al desafío",
    "inviteOthersToYourTeam": "Invita a otros a tu equipo",
    "manageTeam": "Dirige el equipo",
    "ft": "pie",
    "lbs": "lbs",
    "cm": "cm",
    "kg": "kg",
    "community": "comunidad",
    "chooseActivity": "Escoje una actividad",
    "Recent": "Reciente",
    "noActivities": "No hay actividades que coincidan",
    "photoChooseText": "Elige",
    "photoCancelText": "Cancelar",
    "signIn": {
        "missingEmail": "Falta la dirección de correo electrónico",
        "missingPassword": "Asegúrate de que colocaste la contraseña",
        "invalidLogin": "Inicio de sesión inválido",
        "accountLocked": "Tu cuenta está bloqueada. Contacta a tu administrador",
        "accountMayNotExist": "No tenemos una cuenta para esta dirección de correo electrónico.",
        "wrongPassword": "Contraseña incorrecta. Inténtalo de nuevo o haz clic en Olvidé la contraseña para poder restablecerla."
    },
    "deleteGoalBonusPoints": "Si no has ganado el bono de asociado aún, no podrás...",
    "havent_tracked_goal": "No has seguido ninguna actividad para esta meta",
    "trackActivity": {
        "search": "Busca actividades…",
        "text": "Monitorea la actividad",
        "done": "Listo",
        "discardChanges": "¿Descartar los cambios?",
        "discardMessage": "¿Estás seguro que quieres salir y descartar tu progreso?",
        "discard": "Descartar",
        "limitMessage": "Solo puedes monitorear hasta siete días a la vez.",
        "inputDescription": "Cantidad de %{activity} para el %{date}",
        "gracePeriod": "Tiene %{n} %{text} para hacer seguimiento de cualquier actividad omitida"
    },
    "dates": "Fechas",
    "pickDates": "Selecciona otras fechas",
    "selectDates": "Selecciona las fechas",
    "limitReached": "Has alcanzado el límite",
    "activity": "Actividad",
    "keepUpTheGoodWork": "¡Sigue con el buen trabajo!",
    "activityTracked": "Actividad monitoreada",
    "new": "Nuevo",
    "newFeatureTitle": "Monitoreo de actividades más fácil y rápido",
    "newFeatureText": "Ya sea que estés siguiendo la actividad de hoy, el pasado, o de varios días, creemos que te encantará la nueva experiencia.",
    "gotIt": "¡Entendido!",
    "frequencyViewHistory": "Ver el resumen %{frequency}",
    "challengeDetails": {
        "trackTheseActivities": "Monitorea cualquiera de estas actividades para progresar en este\/a %{challengeType}."
    },
    "member": "miembro",
    "weeklyBreakdown": "Resumen semanal",
    "setGoals": {
        "earnPointsText": {
            "start": "¡Gane",
            "end": "por establecer su primer objetivo!"
        }
    },
    "weeklyGoalEnded": "La semana terminó el",
    "weekFinished": "Terminaste una semana de",
    "restartGoal": {
        "daysLeftToTrack": "Aún te faltan %{quantity} %{days} para seguir el progreso que se te haya olvidado la semana pasada.",
        "weekEnded": "Esta semana terminó.",
        "timesUp": "¡Se acabó el tiempo!",
        "period": {
            "title": "Periodo del objetivo",
            "text": "De lunes a domingo, cada semana"
        }
    },
    "membersPlural": "Miembros",
    "startedADayAgo": "Inició hace 1 día",
    "goalRestarted": "Reiniciaste este objetivo",
    "weeklyGoals": "Objetivos semanales",
    "weeklyGoalsDescription": "Los objetivos semanales se renuevan cada lunes, para que puedas mantener un hábito saludable durante un largo tiempo.",
    "challengeEnded": "Este %{challengeType} ha finalizado",
    "goalEndedModalTitle": "Ponte al día con la actividad olvidada",
    "yourProgress": "Tu progreso",
    "earn_withRewards": "Realice un seguimiento de su actividad saludable para ganar (%{pts}) y pasar niveles. Cuando subas de nivel, obtendrás %{currency}.",
    "earn_noRewards": "Suivez votre exercice et votre activité de bien-être pour gagner (%{pts}) et passer au niveau supérieur.",
    "currentPeriod": "Período actual",
    "currentScore": "Puntaje actual",
    "viewActivityLog": "Ver registro de actividad",
    "balanceHistory": "Mi historial de saldo",
    "mymedibank": {
        "underAge": {
            "error": "La app Live Better solo está disponible para usuarios mayores de 18 años; lee los Términos y condiciones de Live Better para más información."
        }
    },
    "enhancedHomePageInfo": "¡Hemos ordenado la página de Inicio! Ahora es más fácil ver tus desafíos y objetivos. ¡Es hora de hacer un monitoreo!",
    "levelUpTitle": "Sube de nivel",
    "levelUpDescription": "Supera los niveles monitoreando actividades y cumpliendo metas y desafíos. ¡A medida que subas de nivel, te recompensaremos con %{currency}!",
    "achievementsDescription": "Desbloquea estas insignias especiales para ganar %{currency}. Haz clic en la insignia para ver qué tienes que hacer.",
    "bonusChallengesDescription": "Únete y completa los desafíos que tienen un bono de %{currency}.",
    "earnWithPartners": {
        "title": "Gana con compañeros",
        "description": "Los miembros de Medibank con cobertura hospitalaria o adicional pueden ganar puntos en compras\/actividades elegibles con socios."
    },
    "browseAllPartners": "Echa un vistazo a todos los compañeros",
    "resetsIn": "Se reinicia en %{daysNumber} días",
    "thisIsALot": "¡Esto es mucho!",
    "areYouSure": "¿Estás seguro?",
    "trackingALotMessage": {
        "days": "Estás monitoreando más de 2.000 %{customPoints} en %{daysNum} días. ¡Eso es mucho!",
        "day": "Estás monitoreando más de 2.000 %{customPoints} en 1 día. ¡Eso es mucho!"
    },
    "amSure": "Estoy seguro",
    "activeMinutesAndSleep": {
        "title": "Seguimiento con el dispositivo para registrar los minutos de actividad y sueño",
        "description": "Su dispositivo registra los minutos durante los cuales lleva a cabo una actividad de esfuerzo físico moderado o intenso, que representa buen ejercicio. ¿Usa un dispositivo para llevar un seguimiento de su sueño? ¡También ganará %{points} por eso!"
    },
    "hourShort": "hora",
    "hoursShort": "horas",
    "secondsShort": "seg",
    "watchToEarn": "Mire para ganar",
    "oneParticipant": "1 participante",
    "oneTeam": "1 Equipos",
    "numberOfTeams": "%{num} teams",
    "inviteToYourTeam": "Invite a su equipo",
    "inviteToThisChallenge": "Invite a este desafío",
    "challengeInstructionText": "Haga seguimiento de esta actividad para avanzar en su %{challengeType}.",
    "showLess": "Mostrar menos",
    "startsTomorrow": "Comienza mañana",
    "deadlineDayLeft": "día restante",
    "deadlineDaysLeft": "días restantes",
    "deviceBonus": "bono de dispositivo",
    "appsAndDevices": {
        "header": "Aplicaciones y dispositivos",
        "linked": "Estas apps y dispositivos vinculados están llevando un seguimiento para este %{challengeType}:",
        "noLinked": "No apto para ninguna app ni dispositivo vinculado",
        "link": "Vincula tu teléfono, reloj o app para llevar un seguimiento automáticamente."
    },
    "yourGoals": "Sus metas",
    "yourChallenges": "Tus desafíos",
    "position": "Posición",
    "team_success": "Éxito del equipo",
    "starts_in": "Comienza en",
    "team_challenge": "Desafío en equipo",
    "your_progress_today": "Su progreso hoy",
    "your_daily_avarage": "Su promedio diario es",
    "this_week_progress": "Progreso de esta semana",
    "this_month_progress": "Progreso de este mes",
    "overall_progress": "Progreso general",
    "complete": "completar",
    "overallSuccess": "Éxito general",
    "teamSuccessAverage": "Promedio del éxito en equipo",
    "progressDetails": "Detalles del progreso",
    "dayStreak": "¡Racha de %{n} días!",
    "weekStreak": "¡Racha de %{n} semanas!",
    "dailyProgress": "Progreso diario",
    "participantsSuccessCount": {
        "overall": "%{amount} de %{total} participantes han alcanzado el objetivo",
        "day": "%{amount} de %{total} participantes han alcanzado el objetivo hoy",
        "week": "%{amount} de %{total} participantes han alcanzado el objetivo esta semana",
        "month": "%{amount} de %{total} participantes han alcanzado el objetivo este mes"
    },
    "doubleBonusShort": "¡Bonificación doble!",
    "doubleBonusLong": "¡Ganaste una bonificación doble!",
    "recommendedGoalDescription": "¡Las metas te ayudan a mantenerte al día con tu progreso y mantener la motivación!",
    "noParticipation": "Sin participación",
    "nothingToShow": "Parece que no hay nada qué mostrar ahora",
    "yourTeam": "Tu equipo",
    "no_activity_title": "Sin actividad",
    "brandSupport": {
        "description": "Hemos agregado compatibilidad de sincronización de actividades con relojes inteligentes Polar y Withings. ¡Hora de moverse!"
    },
    "no_tracked_activities": "No has monitoreado ninguna actividad todavía",
    "button_leave_community": "Dejar la comunidad",
    "button_delete_challenge": "Eliminar %{challengeType}",
    "button_delete_community": "Eliminar comunidad",
    "button_delete_activity": "Eliminar actividad",
    "library_header_description": "Contenido original para educarte, involucrarte e inspirarte a lo largo de tu camino del bienestar.",
    "library_searchbar": "Buscar en la biblioteca…",
    "library_page_header": "Contenido original para educarte, involucrarte e inspirarte a lo largo de tu camino del bienestar.",
    "onboarding_button_title": "He terminado",
    "refresh_bar": "Haz clic aquí para actualizar",
    "content": {
        "min_read": "%{readingTime} min de lectura"
    },
    "noMembers": "Sin miembros",
    "saved": "Salvado",
    "forYou": "Para ti",
    "min read (Note: min as in minutes)": "",
    "send me program related email notifications": "",
    "send me weekly email updates": "",
    "you can earn this bade once every quarter": "",
    "badgeInstruction": "%{badgeInstruction} por",
    "youCanEarnThisBadge": "Puedes ganar esta insignia una vez cada %{period}",
    "emailPreferences": "Preferencias de correo electrónico",
    "unsubscribeText": "Optar por no recibir todas las actualizaciones por correo electrónico",
    "savingText": "Guardando...",
    "wrongTryLater": "Algo salió mal. Por favor, inténtelo de nuevo más tarde.",
    "preferencesSaved": "Preferencias guardadas",
    "recommendedForYou": "Recomendado para ti",
    "formerMember": {
        "label": "Ex miembro"
    },
    "selectionsFromLibrary": "Selecciones de nuestra biblioteca, elegidas especialmente para ti",
    "goalsInfo": {
        "desc1": "para que puedas concentrarte en tu bienestar.",
        "desc2": "Has establecido la cantidad máxima de metas."
    },
    "createMyOwn": "Crea la tuya propia",
    "isAllSet": "¡Ya está todo listo!",
    "undoLabel": "Deshacer",
    "terms": "Términos",
    "placeOrder": "Realizar pedido",
    "item": "Artículo",
    "redeemFor": "Canjear por",
    "confirmYourOrder": "Confirma tu pedido",
    "orderComplete": "Pedido finalizado",
    "redeemedFor": "Canjeado por",
    "orderDetails": "Detalles del pedido",
    "bonusGoalReward": "Premio de meta adicional",
    "orderSummary": "Resumen del pedido",
    "logoutSSO": {
        "title": "Saliste de %{programName}.",
        "description": "¡Te veo de nuevo pronto!",
        "signinAgain": "Haga clic aquí para iniciar sesión de nuevo"
    },
    "nothing_to_show": "Nada que mostrar en este momento",
    "no_saved_content": "No tienes contenidos guardados",
    "restarts_every_week": "Vuelve a comenzar cada semana",
    "myGoals": "Mis metas",
    "goalGallery": "Galería de metas",
    "share_smth": "Comparte algo...",
    "newFeatureModal": {
        "smartGoal": {
            "title": "¡Nuestra meta de pasos ahora es más inteligente!",
            "description": "Tus semanas cambian constantemente. ¡Ahora, tus objetivos también! \n Al usar el modo inteligente, tu meta de pasos se ajustará con base en tu actividad de la vida real.\n Se creó con tu éxito y bienestar en mente.",
            "action": "¡Échale un vistazo!"
        },
        "mePage": {
            "title": "El nuevo yo",
            "description": "Rediseñamos la sección Yo para que encontrar las cosas que te interesan sea más fácil. ¡Compruébalo!",
            "letsSeeBtn": "¡Vamos a ver!",
            "llaterBtn": "tal vez más tarde"
        },
        "bellEAP": {
            "title": "¡Te damos la bienvenida a la plataforma en línea del Programa de Asistencia a Empleados y Familias!",
            "description": "Descubre las herramientas y servicios de apoyo al bienestar y los desafíos a tu disposición y a la de los miembros de tu familia que reúnan los requisitos necesarios",
            "button": "Conéctate ahora o visita la página de enlaces rápidos en cualquier momento"
        },
        "quickActivityLogView": {
            "title": " Una forma más rápida de ver tu actividad reciente",
            "description": "Ahora puede hacer clic en la barra de progreso para ver su registro de actividad."
        }
    },
    "goalSmartMode": {
        "title": "Modo Inteligente",
        "description": "Recibe objetivos semanales personalizados con base en tu nivel de actividad reciente.",
        "status": "Para esta meta, el modo inteligente está %{status}.",
        "infoModal": {
            "descriptionOne": "Al tener el modo inteligente encendido, el objetivo de esta meta cambiará de una semana a otra con base en tu nivel de actividad reciente.",
            "descriptionTwo": "Te desafiaremos lo suficiente para que estés listo para alcanzar el éxito.",
            "instructions": ""
        },
        "settings": {
            "switch": "Habilitar el modo inteligente para mi meta de pasos",
            "description": "Cuando el modo inteligente está encendido, recibirás una nueva meta de pasos al principio de cada semana."
        },
        "enableSmartMode": "Habilitar el modo inteligente",
        "settingsModal": {
            "descriptionTurnOn": "Tu meta de pasos cambiará cada semana con base en tu actividad",
            "descriptionTurnOff": "Tu meta de pasos ya no se personalizará cada semana"
        }
    },
    "On": "Encendido",
    "Off": "Apagado",
    "top_posts": "Publicaciones más populares",
    "most_recent": "Más reciente",
    "browseByTopic": "Ver por tema",
    "video": "Video",
    "enable": "Habilitar",
    "turnOff": "Deshabilitar",
    "new_post": "Nueva publicación",
    "new_post_in": "Nueva publicación en",
    "dailyTarget": "Objetivo diario",
    "dailyTargetForWeek": "Objetivo diario para la semana",
    "showMyActivityLog": "Mostrar mi registro de actividad",
    "usersReacted": {
        "oneOther": "%{userName} y 1 más",
        "multipleOthers": "%{userName} y %{count} otras"
    },
    "reactionsModal": {
        "title": "Más formas de celebrar",
        "description": "¡Anima a tus colegas con nuevas reacciones a publicaciones sociales!"
    },
    "account": "Cuenta",
    "myWellbeingProfile": "Mi perfil de bienestar",
    "physicalDetailsDescription": "Esta información es necesaria para calcular su puntuación de bienestar.",
    "wellbeingInterests": "Intereses de bienestar",
    "myWellbeingInterests": "Mis intereses de bienestar",
    "preferredNameOptional": "Nombre preferido (opcional)",
    "basicPhysicalDetails": "Detalles fisicos basicos",
    "notRegistered": {
        "infoModal": {
            "title": "No podemos encontrarte",
            "notInSystem": "no está en nuestro sistema.",
            "correctEmail": "Asegúrate de utilizar la cuenta correcta (normalmente una dirección de correo electrónico de la empresa) y verifica que no tenga errores.",
            "emailHelp": "Si necesitas más ayuda, envía un correo electrónico a nuestro equipo de asistencia a"
        }
    },
    "dontHaveAccount": "¿No tienes una cuenta?",
    "wasThisHelpful": "¿Fue útil?",
    "healthScoreFeedbackModal": {
        "emojiSection": "¿En qué medida es útil esta página y tu puntaje de bienestar?",
        "commentSectionText": "¿Cómo podrían mejorarse?",
        "commentSectionPlaceholder": "Agrega un comentario...",
        "thankYouModal": "¡Gracias por tus comentarios!"
    },
    "number_connected": "%{numDevices} conectado",
    "searchPlaceHolder": "Busca...",
    "noTeamsFound": "No se han encontrado equipos",
    "join_a_challenge": "Únete a un desafío",
    "me_page_titles": {
        "goal": {
            "singular": "meta",
            "plural": "metas"
        },
        "challenge": {
            "singular": "desafío",
            "plural": "desafíos"
        }
    },
    "seeMoreText": "...ver más",
    "adjust_entry": "Por favor, modifica el aporte.",
    "overTracking": {
        "title": "Aviso de seguimiento excesivo",
        "desc1": {
            "singular": "Este aporte se auditará.",
            "plural": "Estos aportes se auditarán."
        },
        "desc2": "El seguimiento excesivo intencionado puede dar lugar a la suspensión de la cuenta.",
        "button_edit": "Editar mis aportes",
        "button_confirm": "Enviar tal como está"
    },
    "oneEventAttendee": "1 participante",
    "multipleEventAttendees": "%{num} participantes",
    "to": "a",
    "eventBonusFull": "Ganarás %{number} bonus %{points} por asistir a este acto.",
    "eventBonusBold": "%{number} bonus %{points}",
    "didYouLikeArticle": "¿Te gustó este artículo?",
    "didYouLikeVideo": "¿Te gustó este video?",
    "tellUsMore": "Cuéntanos más...",
    "thanksForFeedback": "¡Gracias por tus comentarios!",
    "challengesSubtitle": "Alcanza una meta junto a otros participantes, ¡o juega para ganar!",
    "appStoreNameSprout": "Sprout At Work",
    "appStoreNameLiveBetter": "Vivir mejor de Medibank",
    "appStoreNameTelus": "Salud y bienestar de TELUS",
    "huaweiStoreUrlSprout": "https:\/\/appgallery.huawei.com\/app\/C104993765",
    "telusHealthVirtualCare": "Telus Health Virtual Care",
    "virtualCare": "Virtual Care",
    "changePassword": {
        "telus": {
            "info": "Tu contraseña se gestiona a través de tu cuenta %{telusVC}.",
            "button": "Cambiar mi %{virtualCare} contraseña"
        }
    },
    "actions": "acciones",
    "onAndUpcoming": "Próximamente",
    "termsAndPrivacyPolicyNew": "Al continuar, aceptas",
    "invitedToTeam": "Invitado al equipo de %{firstName} %{lastName}",
    "decline": "Rechazar",
    "invitedToChallenge": "Invitado por %{firstName} %{lastName}",
    "goalsCard": {
        "emptyStateTitle": "No tienes ninguna meta fijada"
    },
    "huaweiStoreUrlTelus": "https:\/\/appgallery.huawei.com\/app\/C107357173",
    "challengesCard": {
        "emptyStateTitle": "No estás en ningún desafío",
        "buttonLabel": "Explorar los desafíos"
    },
    "menu": "Menú",
    "everyone": "Todos",
    "confirmEmployeeID": "Confirmar ID de empleado",
    "employeeIDNoMatch": "Estas identificaciones aún no coinciden",
    "hidePost": "Ocultar los mensajes por %{ownerName}",
    "hidingUserPostToast": {
        "success": {
            "title": "Usuario oculto",
            "message": "No verás más mensajes de este usuario."
        }
    },
    "moderateHideUserDescription": "Al ocultar las publicaciones de este usuario, se eliminará el contenido específico del usuario de la publicación de las novedades.",
    "startsInOneDay": "Comienza en 1 día",
    "endsInOneDay": "Finaliza en 1 día",
    "endsToday": "Finaliza hoy",
    "hrisEmployeeID": {
        "infoModal": {
            "notInSystem": "no está en nuestro sistema. ¿Lo has ingresado correctamente?",
            "administrator": "Si eres un empleado nuevo, es posible que aún no tengamos tu ID de empleado. Por favor, pregunta a tu administrador sobre cuándo volver a intentarlo.",
            "emailNotInSystem": "Si eres un empleado nuevo, es posible que tu correo electrónico aún no se haya agregado a nuestro sistema. Por favor, pregunta a tu administrador sobre cuándo volver a intentarlo.",
            "eligibleEmail": "no es una dirección de correo electrónico elegible. ¿Lo has ingresado correctamente?"
        }
    },
    "oneMember": "1 miembro",
    "programCode": {
        "infoModal": {
            "unique": "Tu empresa dispone de un código de programa exclusivo que suele enviarse por correo electrónico.",
            "support": "Si no encuentras tu código, ponte en contacto con el administrador de tu programa de bienestar o envía un correo electrónico a support@sproutatwork.com con el nombre de tu empresa."
        },
        "instructions": "Ingresa el código del programa facilitado por tu empresa para empezar"
    },
    "whatsMyProgramCode": "¿Cuál es mi código de programa?",
    "enjoyApp": "Disfruta de nuestra app móvil",
    "programCodeLabel": "Código de programa",
    "createdByMembersChallenges": "Creado por los miembros",
    "invites": "Invitaciones",
    "recommendedContentTitle": "Selecciones de la biblioteca para ti",
    "amountExchanged": "Monto canjeado",
    "orderStatus": "Estado del pedido",
    "orderSuccessfulyyItemForConfirmation": "Pedido realizado con éxito Se ha enviado una confirmación a %{email}.",
    "orderedOnDateText": "Pedido el %{orderCreatedTime}",
    "personalize": {
        "communities": {
            "title": "Únete a las comunidades",
            "description": "Las comunidades conectan a personas con intereses comunes. Puedes unirte o abandonar comunidades en cualquier momento."
        },
        "objectives": {
            "title": "Mis objetivos",
            "description": "¿Qué podemos ayudarte a poner en marcha o mantener? Lo utilizaremos para mejorar nuestras recomendaciones."
        },
        "topics": {
            "title": "Mis temas de bienestar",
            "description": "Podrás ver más consejos y contenidos prácticos sobre estas selecciones."
        }
    },
    "recommendedCardDesc": "Fíjate hasta 3 metas para mejorar tu bienestar",
    "accessibility": {
        "track_activity": "Dar seguimiento a la actividad",
        "cardbody": "Cuerpo de la tarjeta",
        "cardcontainer": "Contenedor de la tarjeta",
        "cardfooter": "Pie de la tarjeta",
        "unstartedChallengeHeader": "Desafío no iniciado",
        "activeOrEndedChallengeWrapper": "Envoltorio del desafío",
        "activeOrEndedChallengeHeader": "Título del desafío",
        "goalHeader": "Título de la meta",
        "openOptions": "Opciones abiertas"
    },
    "teams": {
        "teamInvites": "Invitaciones de equipo",
        "findTeam": "Encontrar un equipo",
        "teamFull": "El equipo está lleno"
    },
    "deleteAccountText": "Elimina permanentemente tu cuenta de Sprout At Work y todos sus datos",
    "deleteAccountButtonTitle": "Eliminar mi cuenta",
    "joinTeamActionSheetText": "Únete o crea un equipo para participar en este desafío",
    "frequencyNone": "ninguno",
    "quickLinkTitle": "Enlaces rápidos",
    "moreTab": "Más",
    "addedBy": "Agregado por %{companyName}",
    "teamsTitle": "Equipos",
    "helpAndSupport": "Ayuda y soporte para la app",
    "feedbackTitle": "Proporcionar retroalimentación",
    "feedbackDescription": "Dinos qué te gusta de la app y en qué podemos mejorar.",
    "leaveTeamAction": "Dejar el equipo",
    "teamActions": "Acciones del equipo",
    "leaveTeamLeaveChallenge": "Si dejas este equipo, significa que dejas el desafío. Tendrás que unirte a un equipo para seguir participando.",
    "familyMembers": "Miembros de la familia",
    "familyMembersDescription": "Los miembros de la familia deben ser mayores de 16 años. Tendrán pleno acceso y visibilidad en toda la plataforma.",
    "learnMoreButton": "Aprender más",
    "thvcSelection": {
        "signUpUsingTelus": "Inscríbete utilizando tu cuenta de Telus Health Virtual Care (Atención virtual para la salud de TELUS)",
        "loginGetStarted": "Conéctate a Virtual Care para empezar",
        "haveAccount": "¿Tienes una cuenta de Virtual Care?",
        "emailHelp": "¿Necesita ayuda? Ponte en contacto con nuestro equipo de asistencia en",
        "yes": "Sí",
        "signMeUp": "No, apúntenme"
    },
    "inviteFamilyMember": {
        "label": "Invitar a miembros de la familia",
        "btn": "Enviar invitación",
        "email": "Correo electrónico*",
        "firstName": "Nombre*",
        "lastName": "Apellido*",
        "approval": "Confirmo que tengo autorización para invitar a este miembro de la familia al %{company}",
        "multiSelect1": "¿Este miembro de la familia es mayor de edad en tu región?",
        "multiSelect2": "¿Este miembro de la familia tiene al menos 16 años?",
        "confirmTermsPolicy": "Confirmo que soy el tutor legal de esta persona. Yo creo que el dependiente es lo suficientemente maduro como para aceptar el uso de la plataforma, y doy mi consentimiento para que se una. Explicaré al dependiente la necesidad de que sea responsable en la plataforma y la forma en que se recopilan y utilizan sus datos.",
        "onTheirBehalf": "en su nombre.",
        "confirm": "Sí, confirmo lo anterior",
        "warning": "El miembro de la familia debe tener al menos 16 años para inscribirse",
        "errorMsg": "Revisa los errores antes de intentar continuar"
    },
    "deleteFamilyMember": {
        "desc": "La eliminación de la cuenta de un miembro de la familia es permanente.",
        "btn": "Eliminar a miembros de la familia",
        "confirmation": {
            "title": "Miembro de la familia eliminado",
            "desc": "La cuenta de %{fullName} se ha eliminado"
        },
        "areYouSure": "¿Tienes a certeza de que quieres eliminar la cuenta de %{fullName}?"
    },
    "familyInvitationStatus": {
        "active": "Activo",
        "sent": "Invitación enviada"
    },
    "familyInvitationSent": {
        "title": "Se ha enviado el correo electrónico de invitación",
        "desc": "Invitación enviada a %{fullName}"
    },
    "programCodeSignup": "Utiliza %{programCodeLabel} %{programCode} después de hacer clic en '%{signUpLabel}'",
    "notJoinedCommunityLabel": "Únete a esta comunidad para ver lo que comparten los miembros",
    "moda": {
        "installApp": {
            "title": "Tenga en cuenta: los miembros de Moda Health solo pueden acceder a Sprout at Work a través de su Panel de miembros.",
            "subtitle": "Para utilizar Sprout at Work en tu teléfono inteligente:",
            "stepOneA": "1. Instala la app móvil Sprout at Work.",
            "stepOneB": "No se registre ni inicie sesión en la aplicación móvil.",
            "stepTwo": "2. Inicie sesión en su Panel de miembro en su teléfono móvil",
            "stepThree": "3. Navega hasta el programa de bienestar Sprout y sigue el enlace; debería abrir la aplicación móvil Sprout at Work."
        }
    },
    "HRISLocationSelection": {
        "title": "¿Desde qué país trabajas?"
    },
    "visibilitySettings": {
        "title": "Configuración de visibilidad",
        "desc1": "¿Está bien ser visible para otros miembros de la aplicación Bienestar de su empresa?",
        "desc2": "Siempre puedes cambiar esto más tarde.",
        "moreTextQ1": "¿Qué pueden ver otras personas?",
        "moreTextAnswer1": "Las personas de su empresa pueden ver su nombre, foto de perfil y detalles básicos del perfil (como departamento y ubicación). Esto hace que la aplicación sea más social y divertida.",
        "moreTextQ2": "¿Dónde aparezco?",
        "moreTextAnswer2": "Aparecerás como participante de los desafíos, comunidades y eventos a los que te unas, en tablas de clasificación y en los resultados de búsqueda. Puedes ajustar esto más tarde.",
        "moreTextAnswer3": "No compartimos ni mostramos su información de salud personal, como su altura, peso o la actividad que realiza.",
        "btnAgree": "Está bien que me lo muestres",
        "btnDisagree": "No dejes que otros miembros me vean."
    },
    "privacyPolicyReadMore": "Para obtener más información, lea nuestra Política de Privacidad",
    "tellMeMore": "Cuéntame más",
    "helpUsImprove": {
        "title": "Ayúdanos a mejorar",
        "desc1": "Utilizamos herramientas que registran datos de uso anónimos. Ver las tendencias en lo que la gente ve y hace clic nos ayuda a mejorar la aplicación.",
        "desc2": "Puedes desactivar esto en cualquier momento.",
        "moreTextQ1": "lo que miramos",
        "moreTextAnswer1": "Nos interesan las tendencias y estadísticas generales, por lo que no analizamos los datos a nivel individual.",
        "moreTextQ2": "No compartimos tus datos",
        "moreTextAnswer2": "Estos datos solo están disponibles para las personas que crean esta aplicación para ayudar a mejorarla. No lo compartimos con otras empresas, incluido su empleador.",
        "moreTextQ3": "Tus datos son anónimos",
        "moreTextAnswer3": "Nuestras herramientas no registran su nombre, ubicación exacta ni ninguna información de salud personal.",
        "btnAgree": "Seguimiento de mi uso de forma anónima",
        "btnDisagree": "No doy mi consentimiento para el seguimiento"
    },
    "deleteAccountTextAppName": "Elimina permanentemente tu cuenta %{appName} y todos sus datos",
    "anonymousMember": "Miembro anónimo",
    "activitiesToTrack": {
        "title": "Actividades para seguir"
    },
    "includedInMembership": "Incluido en tu membresía",
    "invalidDate": "Fecha invalida",
    "discardsStreamPost": {
        "discardTitle": "¿Descartar publicación?",
        "discardChangesTitle": "¿Descartar cambios?",
        "discardPostText": "¿Estás seguro de que quieres descartar tu publicación?",
        "discardPostChangesText": "¿Está seguro de que desea descartar los cambios?"
    },
    "trackActivityModalTitle": "Seguimiento de %{date}",
    "noPosts": "No hay publicaciones para ver",
    "goalIcon": "Icono de objetivo",
    "resetsOn": "Se reinicia el %{date}",
    "clickForHelp": "Haga clic aquí para obtener ayuda",
    "trackActivityInputLabel": "Ingrese %{unit} %{activityName} %{dateFormat}",
    "itemsFound": "Artículos encontrados",
    "tagState": {
        "active": "Activo",
        "notActive": "No activo"
    },
    "bonusCheckmarkLabel": "Recibiste %{bonusLabel} puntos de bonificación por completar",
    "searchBar": {
        "searching": "buscando %{term}",
        "result": "resultados de búsqueda"
    },
    "activityProgress": "Progreso de la actividad: %{levelName} %{percentFilled}%: se reinicia en %{daysLeft} días",
    "bookmark": {
        "remove": "Eliminar de elementos guardados",
        "save": "Guardar este artículo"
    },
    "bonusMark": {
        "earn": "Gana %{qty} %{points}",
        "earned": "Ganaste %{qty} %{points}"
    },
    "tabToTrackActivity": "Toca para seguir la actividad",
    "videoElementLabel": "%{title}, duración %{duration}, toca dos veces para reproducir el vídeo",
    "updatedPoliciesPopup": {
        "title": "Hemos actualizado nuestros términos",
        "details": "Le recomendamos que lea nuestras políticas actualizadas a continuación:",
        "disclaimer": "Al hacer clic en el botón a continuación, acepta y reconoce las políticas actualizadas.",
        "agree": "Estoy de acuerdo"
    },
    "editActivityLog": {
        "canNotEditItem": "No puedes editar esta entrada",
        "canNotEditItemDescription": "La edición no está disponible para actividades sincronizadas desde dispositivos o aplicaciones.",
        "updatedItem": "Actividad actualizada",
        "updatedItemDescription": "Tus cambios se han guardado."
    },
    "login_with_email": "Iniciar sesión con correo electrónico",
    "healthconnect_not_available": "No se puede conectar a Health Connect. En la aplicación Health Connect, asegúrese de que los permisos estén habilitados.",
    "registrationField": {
        "required": {
            "firstName": "Por favor, introduzca su nombre",
            "lastName": "Por favor, introduzca su apellido",
            "email": "Por favor, introduce una dirección de correo electrónico válida",
            "password": "Por favor, introduzca una contraseña válida"
        }
    },
    "settingsErrorMessage": {
        "firstName": "Por favor ingresa tu nombre",
        "lastName": "Por favor ingresa tu apellido"
    },
    "requiredValidValue": "Por favor ingresa un valor válido para tu %{value}",
    "passwordHidden": "Contraseña oculta, toque para mostrar la contraseña",
    "passwordShown": "Se muestra la contraseña, toque para ocultar la contraseña",
    "libraryHeaderContent": {
        "category": "",
        "points": "Gana %{points} puntos."
    },
    "scoreCurrentPeriod": "%{text} es de %{startDate} a %{endDate}",
    "scoreCurrent": "%{text} son %{points} puntos",
    "abbotResetPasswordModal": {
        "title": "¿Estás intentando acceder a una cuenta del año pasado?",
        "text": " Si te registraste en el desafío del año pasado, esa cuenta ya no funcionará. Necesitas registrarte para este año.",
        "goToResetPasswordBtn": "Me registré en %{currentYear}",
        "goToSignupBtn": "No me he registrado en %{currentYear}"
    },
    "challengeRegistrationClosed": "Inscripción cerrada: el desafío ha comenzado",
    "stopSupportGoogleFit": {
        "banner": {
            "title": "Google Fit dejará de estar disponible",
            "description": "Cambia a Health Connect para seguir con el seguimiento automático de tu actividad.",
            "linkBtn": "Cambiar a Health Connect"
        },
        "newFeatureModal": {
            "label": "Acción requerida",
            "title": "Google Fit ya no admite la sincronización de actividades",
            "web": {
                "doNotHaveApp": "¿Aún no tienes nuestra aplicación?",
                "getAppText": "Descárgalo aquí,",
                "dateNotIncludedDescription": "Usa tu smartphone para cambiar a Health Connect de Google.",
                "dateIncludedDescription": "Eliminaremos la integración de Google Fit el %{date}. Usa tu smartphone para cambiar a Health Connect de Google."
            },
            "mobile": {
                "dateNotIncludedDescription": "Cambia a Health Connect para seguir con el seguimiento automático de tu actividad.",
                "dateIncludedDescription": "Eliminaremos la integración de Google Fit el %{date}. Cambia a Health Connect para seguir con el seguimiento automático de tu actividad.",
                "buttonLabel": "Cambiar a Health Connect"
            }
        }
    },
    "RBCTaxableRewardWarning": "Ten en cuenta que cualquier recompensa canjeada a través de la plataforma de bienestar se considerará un beneficio sujeto a impuestos y el valor correspondiente se reflejará como ingreso en tu recibo de pago."
};